(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stb-product-catalog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-favorites-catalog]');
    if (!root) return;
    var grid = root.querySelector('[data-catalog-grid]');
    var filters = root.querySelector('[data-catalog-filters]');
    var search = root.querySelector('[data-catalog-search]');
    var count = root.querySelector('[data-product-count]');
    var selectionStatus = root.querySelector('[data-selection-status]');
    var tray = document.querySelector('[data-quote-tray]');
    var trayItems = tray.querySelector('[data-quote-items]');
    var products = [];
    var selected = {};
    var drafts = {};
    var expandedColors = {};
    var activeCategory = 'all';
    var labels = root.dataset;
    var categoryOrder = ['all', 't-shirts', 'long-sleeve', 'tank-tops', 'performance', 'polos', 'sweatshirts-hoodies', 'outerwear', 'pants-shorts', 'youth', 'womens', 'hats-accessories'];

    function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    }

    function safeUrl(value) {
      try {
        var url = new URL(String(value || ''));
        return url.protocol === 'https:' && !url.username && !url.password && url.hostname.toLocaleLowerCase() === 'cdnm.sanmar.com' ? url.href : '';
      } catch (error) {
        return '';
      }
    }

    function normalize(product) {
      if (!product || !product.productId || !product.name || !product.category) return null;
      var colors = Array.isArray(product.colors) ? product.colors.map(function (color) {
        if (!color || typeof color !== 'object' || !color.name) return null;
        return {
          name: String(color.name),
          sizes: sortSizes(Array.isArray(color.sizes) ? color.sizes.map(String) : [])
        };
      }).filter(Boolean) : [];
      var matrixSizes = colors.reduce(function (values, color) { return values.concat(color.sizes); }, []);
      return {
        productId: String(product.productId),
        name: String(product.name),
        fabric: String(product.fabric || ''),
        fit: String(product.fit || ''),
        brand: String(product.brand || ''),
        style: String(product.style || ''),
        category: String(product.category),
        categoryLabel: String(product.categoryLabel || product.category),
        preferred: product.preferred === true,
        sizes: sortSizes(Array.from(new Set(matrixSizes.length ? matrixSizes : (Array.isArray(product.sizes) ? product.sizes.map(String) : [])))),
        colors: colors,
        favoriteColors: Array.isArray(product.favoriteColors) ? product.favoriteColors.map(String) : [],
        images: Array.isArray(product.images) ? product.images : []
      };
    }

    function sortSizes(values) {
      var order = ['XXS', 'XS', 'S', 'S/M', 'M', 'M/L', 'L', 'L/XL', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL', 'LT', 'XLT', '2XLT', '3XLT', '4XLT', 'OSFA', 'ONE SIZE'];
      return values.slice().sort(function (left, right) {
        var leftIndex = order.indexOf(left.toLocaleUpperCase());
        var rightIndex = order.indexOf(right.toLocaleUpperCase());
        if (leftIndex === -1) leftIndex = order.length;
        if (rightIndex === -1) rightIndex = order.length;
        return leftIndex - rightIndex || left.localeCompare(right, undefined, { numeric: true });
      });
    }

    function categoryLabel(category) {
      var product = products.find(function (item) { return item.category === category; });
      return product ? product.categoryLabel : category;
    }

    function visibleProducts() {
      var term = search.value.trim().toLocaleLowerCase();
      return products.filter(function (product) {
        var inCategory = activeCategory === 'all' || product.category === activeCategory;
        var haystack = [product.name, product.brand, product.style, product.categoryLabel].join(' ').toLocaleLowerCase();
        return inCategory && (!term || haystack.indexOf(term) !== -1);
      });
    }

    function mediaMarkup(product) {
      var images = product.images.filter(function (image) { return image && safeUrl(image.url); });
      var front = images.find(function (image) { return image.view === 'front'; }) || images[0];
      var back = images.find(function (image) { return image.view === 'back'; });
      if (!front) return '<div class="favorite-product__photo favorite-product__photo--empty"><span>' + escapeHtml(labels.photoMissing) + '</span></div>';
      var views = '<button type="button" class="favorite-product__view" aria-pressed="true" data-product-view data-url="' + escapeHtml(front.url) + '" data-alt="' + escapeHtml(front.alt || product.name) + '">' + escapeHtml(labels.front) + '</button>';
      if (back) views += '<button type="button" class="favorite-product__view" aria-pressed="false" data-product-view data-url="' + escapeHtml(back.url) + '" data-alt="' + escapeHtml(back.alt || product.name) + '">' + escapeHtml(labels.back) + '</button>';
      return '<figure class="favorite-product__media"><div class="favorite-product__photo"><img loading="lazy" src="' + escapeHtml(front.url) + '" alt="' + escapeHtml(front.alt || product.name) + '" data-product-image></div><figcaption class="favorite-product__views">' + views + '</figcaption></figure>';
    }

    function chips(values) {
      return values.length ? values.map(function (value) { return '<span class="favorite-product__chip">' + escapeHtml(value) + '</span>'; }).join('') : '—';
    }

    function swatchColor(name) {
      var value = String(name || '').toLocaleLowerCase();
      var colors = [
        ['black', '#151716'], ['charcoal', '#4b4f4c'], ['graphite', '#5c605d'], ['grey', 'var(--color-text-faint)'], ['gray', 'var(--color-text-faint)'],
        ['white', '#ffffff'], ['natural', '#e8dfc8'], ['ivory', '#f4edda'], ['cream', '#eee2bf'], ['sand', '#cbb990'],
        ['navy', '#142b4a'], ['royal', '#2454a6'], ['blue', '#3976b8'], ['aqua', '#47b8c6'], ['teal', '#247f80'],
        ['turquoise', '#37aeb0'], ['green', '#2d7748'], ['olive', '#667044'], ['lime', '#73a942'], ['mint', '#86c8aa'],
        ['maroon', '#6e2436'], ['burgundy', '#702f3b'], ['red', '#b92f35'], ['scarlet', '#c92e36'], ['cardinal', '#9c2935'],
        ['orange', '#dc6b2c'], ['gold', '#d4a72c'], ['yellow', '#e4c83d'], ['purple', '#694b8f'], ['violet', '#7457a6'],
        ['pink', '#d8799a'], ['coral', '#d96f63'], ['brown', '#72513d'], ['khaki', '#a69068'], ['tan', '#b59a72'],
        ['silver', '#b8bdb9']
      ];
      var match = colors.find(function (entry) { return value.indexOf(entry[0]) !== -1; });
      return match ? match[1] : '#9aa19b';
    }

    function swatchFill(name) {
      return swatchColor(name);
    }

    function productDraft(product) {
      if (!drafts[product.productId]) drafts[product.productId] = { colors: {} };
      return drafts[product.productId];
    }

    function configuredQuantity(configuration) {
      return Object.keys(configuration.colors || {}).reduce(function (total, colorName) {
        var sizes = configuration.colors[colorName].sizes || {};
        return total + Object.keys(sizes).reduce(function (sum, size) { return sum + (Number(sizes[size]) || 0); }, 0);
      }, 0);
    }

    function swatchMarkup(product, color) {
      var isSelected = Boolean(productDraft(product).colors[color.name]);
      return '<button type="button" class="favorite-product__swatch" aria-pressed="' + isSelected + '" aria-label="' + escapeHtml((isSelected ? 'Remove ' : 'Select ') + color.name) + '" data-select-color="' + escapeHtml(color.name) + '" style="--swatch-fill:' + escapeHtml(swatchFill(color.name)) + '"><span class="favorite-product__swatch-name">' + escapeHtml(color.name) + '</span></button>';
    }

    function colorSwatches(product) {
      var colors = product.colors;
      if (!colors.length) return '—';
      var limit = 12;
      var first = colors.slice(0, limit).map(function (color) { return swatchMarkup(product, color); }).join('');
      var remaining = colors.slice(limit);
      if (!remaining.length) return '<div class="favorite-product__swatches">' + first + '</div>';
      return '<div class="favorite-product__swatches">' + first + '</div><details class="favorite-product__more-colors" data-more-colors' + (expandedColors[product.productId] ? ' open' : '') + '><summary>+' + remaining.length + ' more colors</summary><div class="favorite-product__swatches">' + remaining.map(function (color) { return swatchMarkup(product, color); }).join('') + '</div></details>';
    }

    function configurationMarkup(product) {
      var configuration = productDraft(product);
      var colorNames = Object.keys(configuration.colors);
      if (!colorNames.length) return '<div class="favorite-product__config"><p class="favorite-product__config-empty">Choose one or more colors, then enter quantities by size.</p></div>';
      return '<div class="favorite-product__config">' + colorNames.map(function (colorName) {
        var color = product.colors.find(function (candidate) { return candidate.name === colorName; });
        if (!color) return '';
        var quantities = configuration.colors[colorName].sizes || {};
        return '<fieldset class="favorite-product__color-line"><legend class="favorite-product__color-head"><strong>' + escapeHtml(colorName) + '</strong><button type="button" class="favorite-product__color-remove" data-remove-color="' + escapeHtml(colorName) + '">Remove</button></legend><div class="favorite-product__size-grid">' + color.sizes.map(function (size) {
          return '<label class="favorite-product__qty"><span>' + escapeHtml(size) + '</span><input type="number" inputmode="numeric" min="0" max="999" step="1" value="' + escapeHtml(quantities[size] || '') + '" aria-label="' + escapeHtml(colorName + ' ' + size + ' quantity') + '" data-quantity-color="' + escapeHtml(colorName) + '" data-quantity-size="' + escapeHtml(size) + '"></label>';
        }).join('') + '</div></fieldset>';
      }).join('') + '</div>';
    }

    function mockupLink(product) {
      if (!product.style) return '';
      var params = new URLSearchParams();
      params.set('smartmockup_mode', 'designer');
      params.set('style', product.style);
      var chosen = Object.keys(productDraft(product).colors || {})[0];
      if (chosen) params.set('color', chosen);
      return '<a class="favorite-product__mockup" href="/pages/smartmockup?' + params.toString() + '" data-cta="products-mockup-' + escapeHtml(product.style.toLowerCase()) + '">See it with your logo \u2192</a>';
    }

    function cardMarkup(product) {
      var isSelected = Boolean(selected[product.productId]);
      var details = '';
      if (product.fabric) details += '<p class="favorite-product__description"><strong>' + escapeHtml(labels.fabric) + ':</strong> ' + escapeHtml(product.fabric) + '</p>';
      if (product.fit) details += '<p class="favorite-product__description"><strong>' + escapeHtml(labels.fit) + ':</strong> ' + escapeHtml(product.fit) + '</p>';
      var quantity = configuredQuantity(productDraft(product));
      return '<article class="favorite-product' + (isSelected ? ' favorite-product--selected' : '') + '" data-product-id="' + escapeHtml(product.productId) + '">' + mediaMarkup(product) + '<div class="favorite-product__body"><div class="favorite-product__topline">' + (product.preferred ? '<span class="favorite-product__badge">' + escapeHtml(labels.preferred) + '</span>' : '') + '<span class="favorite-product__category">' + escapeHtml(product.categoryLabel) + '</span></div><h3>' + escapeHtml(product.name) + '</h3><p class="favorite-product__identity">' + escapeHtml([product.brand, product.style ? 'Style ' + product.style : ''].filter(Boolean).join(' · ')) + '</p>' + mockupLink(product) + details + '<div class="favorite-product__meta"><div><strong>Choose colors</strong>' + colorSwatches(product) + '</div></div>' + configurationMarkup(product) + '<button class="btn btn--outline favorite-product__add" type="button" aria-pressed="' + isSelected + '" data-add-product' + (quantity ? '' : ' disabled') + '>' + escapeHtml(isSelected ? 'Update Quote Request' : 'Add Configured Product') + '</button></div></article>';
    }

    function renderFilters() {
      var categories = categoryOrder.filter(function (category) {
        return category === 'all' || products.some(function (product) { return product.category === category; });
      });
      filters.innerHTML = categories.map(function (category) {
        var total = category === 'all' ? products.length : products.filter(function (product) { return product.category === category; }).length;
        var name = category === 'all' ? 'All' : categoryLabel(category);
        return '<button class="favorites-filter" type="button" data-filter="' + escapeHtml(category) + '" aria-pressed="' + (category === activeCategory) + '">' + escapeHtml(name) + '<span>' + total + '</span></button>';
      }).join('');
    }

    function renderProducts() {
      var visible = visibleProducts();
      grid.innerHTML = visible.length ? visible.map(cardMarkup).join('') : '<p class="favorites-catalog__status">' + escapeHtml(labels.empty) + '</p>';
    }

    function productAction(productId) {
      var cards = Array.from(grid.querySelectorAll('[data-product-id]'));
      var card = cards.find(function (candidate) { return candidate.dataset.productId === productId; });
      return card ? card.querySelector('[data-add-product]') : null;
    }

    function restoreProductFocus(productId) {
      window.requestAnimationFrame(function () {
        var target = productAction(productId) || selectionStatus;
        target.focus({ preventScroll: true });
      });
    }

    function announce(message) {
      selectionStatus.textContent = '';
      window.requestAnimationFrame(function () { selectionStatus.textContent = message; });
    }

    function imageUnavailable(image) {
      var card = image.closest('[data-product-id]');
      var photo = image.closest('.favorite-product__photo');
      if (!card || !photo) return;
      var shouldRestoreFocus = document.activeElement && card.contains(document.activeElement);
      photo.classList.add('favorite-product__photo--empty');
      photo.innerHTML = '<span>' + escapeHtml(labels.photoMissing) + '</span>';
      var views = card.querySelector('.favorite-product__views');
      if (views) views.remove();
      announce(labels.imageUnavailable);
      if (shouldRestoreFocus) restoreProductFocus(card.dataset.productId);
    }

    function governedProducts(payload) {
      if (!payload || payload.styleCount !== 95 || payload.selectionCount !== 107) throw new Error('catalog invariant mismatch');
      var values = (Array.isArray(payload.products) ? payload.products : []).map(normalize).filter(Boolean);
      var productIds = new Set(values.map(function (product) { return product.productId; }));
      var styles = new Set(values.map(function (product) { return product.style.toLocaleUpperCase(); }));
      var favoriteSelectionCount = values.reduce(function (total, product) { return total + product.favoriteColors.length; }, 0);
      if (values.length !== 95 || productIds.size !== 95 || styles.size !== 95 || favoriteSelectionCount !== 107) throw new Error('catalog duplicate or count mismatch');
      return values;
    }

    function selectionSummary() {
      return Object.keys(selected).map(function (id) {
        var item = selected[id];
        var lines = Object.keys(item.colors).map(function (colorName) {
          var sizes = item.colors[colorName].sizes;
          var quantities = Object.keys(sizes).filter(function (size) { return sizes[size] > 0; }).map(function (size) { return size + ': ' + sizes[size]; });
          return colorName + ' — ' + quantities.join(', ');
        });
        return item.product.name + ' — Style ' + item.product.style + '\n' + lines.join('\n');
      }).join('\n');
    }

    function syncIntakeForm(items) {
      var form = document.getElementById('canonical-product-quote');
      if (!form) return;
      var total = items.reduce(function (sum, item) { return sum + configuredQuantity({ colors: item.colors }); }, 0);
      var quantity = form.querySelector('[name="estimated_quantity"]');
      if (quantity && total) {
        quantity.value = total <= 24 ? '12–24' : total <= 49 ? '25–49' : total <= 99 ? '50–99' : total <= 249 ? '100–249' : '250+';
      }
      var garment = form.querySelector('[name="garment_type"]');
      if (garment && items.length) {
        var categories = Array.from(new Set(items.map(function (item) { return item.product.category; })));
        var categoryTypes = { 't-shirts': 'T-Shirts', performance: 'Performance Shirts', 'sweatshirts-hoodies': 'Hoodies', 'pants-shorts': 'Shorts / Pants', 'hats-accessories': 'Hats' };
        garment.value = categories.length === 1 && categoryTypes[categories[0]] ? categoryTypes[categories[0]] : 'Multiple Items';
      }
    }

    function syncVisibleSelection(summary) {
      var form = document.getElementById('canonical-product-quote');
      if (!form) return;
      var field = form.querySelector('[data-selected-products-field]');
      if (!field) {
        var details = form.querySelector('[name="additional_project_details"]');
        var detailsLabel = details && details.closest('label');
        if (!detailsLabel) return;
        field = document.createElement('label');
        field.className = 'stb-intake__wide';
        field.setAttribute('data-selected-products-field', '');
        field.innerHTML = 'Selected products<textarea name="selected_products" rows="6" readonly data-selected-products-summary></textarea><span class="stb-intake__help">This exact product, color, size, and quantity summary will be included with your request.</span>';
        detailsLabel.parentNode.insertBefore(field, detailsLabel);
      }
      var output = field.querySelector('[data-selected-products-summary]');
      var value = String(summary || '').trim();
      if (output) output.value = value;
      field.hidden = !value;
    }

    function renderTray() {
      var items = Object.keys(selected).map(function (id) { return selected[id]; });
      tray.hidden = items.length === 0;
      trayItems.innerHTML = items.length ? items.map(function (item) {
        var quantity = Object.keys(item.colors).reduce(function (total, colorName) { return total + configuredQuantity({ colors: (function () { var value = {}; value[colorName] = item.colors[colorName]; return value; })() }); }, 0);
        return '<span class="quote-tray__item"><button class="quote-tray__edit" type="button" data-edit-product="' + escapeHtml(item.product.productId) + '">' + escapeHtml(item.product.style + ' · ' + quantity + ' pieces') + '</button><button class="quote-tray__remove" type="button" data-remove-product="' + escapeHtml(item.product.productId) + '" aria-label="' + escapeHtml(labels.remove + ' ' + item.product.name) + '">×</button></span>';
      }).join('') : escapeHtml(labels.trayEmpty);
      syncIntakeForm(items);
      window.__stbTeamStoreSelection = selectionSummary();
      syncVisibleSelection(window.__stbTeamStoreSelection);
      window.dispatchEvent(new CustomEvent('stb:team-store-selection', { detail: { summary: window.__stbTeamStoreSelection } }));
    }

    function render() {
      renderFilters();
      renderProducts();
      renderTray();
    }

    root.addEventListener('click', function (event) {
      var filter = event.target.closest('[data-filter]');
      if (filter) {
        activeCategory = filter.dataset.filter;
        renderFilters();
        renderProducts();
        window.requestAnimationFrame(function () {
          var replacement = filters.querySelector('[data-filter="' + activeCategory + '"]');
          if (replacement) replacement.focus({ preventScroll: true });
        });
        return;
      }
      var add = event.target.closest('[data-add-product]');
      if (add) {
        var card = add.closest('[data-product-id]');
        var product = products.find(function (item) { return item.productId === card.dataset.productId; });
        if (!product) return;
        var configuration = productDraft(product);
        if (!configuredQuantity(configuration)) return;
        selected[product.productId] = { product: product, colors: JSON.parse(JSON.stringify(configuration.colors)) };
        renderProducts();
        renderTray();
        restoreProductFocus(product.productId);
        announce(labels.selectionAdded);
        return;
      }
      var swatch = event.target.closest('[data-select-color]');
      if (swatch) {
        var swatchCard = swatch.closest('[data-product-id]');
        var swatchProduct = products.find(function (item) { return item.productId === swatchCard.dataset.productId; });
        if (!swatchProduct) return;
        var swatchDraft = productDraft(swatchProduct);
        var colorName = swatch.dataset.selectColor;
        if (swatchDraft.colors[colorName]) delete swatchDraft.colors[colorName];
        else swatchDraft.colors[colorName] = { sizes: {} };
        renderProducts();
        var replacementSwatch = productAction(swatchProduct.productId) && grid.querySelector('[data-product-id="' + swatchProduct.productId + '"] [data-select-color="' + CSS.escape(colorName) + '"]');
        if (replacementSwatch) replacementSwatch.focus({ preventScroll: true });
        return;
      }
      var removeColor = event.target.closest('[data-remove-color]');
      if (removeColor) {
        var removeCard = removeColor.closest('[data-product-id]');
        var removeProduct = products.find(function (item) { return item.productId === removeCard.dataset.productId; });
        if (!removeProduct) return;
        delete productDraft(removeProduct).colors[removeColor.dataset.removeColor];
        renderProducts();
        restoreProductFocus(removeProduct.productId);
        return;
      }
      var view = event.target.closest('[data-product-view]');
      if (view) {
        var viewCard = view.closest('[data-product-id]');
        var image = viewCard.querySelector('[data-product-image]');
        if (!image || !safeUrl(view.dataset.url)) return;
        image.src = view.dataset.url;
        image.alt = view.dataset.alt || '';
        viewCard.querySelectorAll('[data-product-view]').forEach(function (button) { button.setAttribute('aria-pressed', String(button === view)); });
      }
    });

    root.addEventListener('toggle', function (event) {
      var details = event.target.closest && event.target.closest('[data-more-colors]');
      if (!details) return;
      var detailsCard = details.closest('[data-product-id]');
      if (detailsCard) expandedColors[detailsCard.dataset.productId] = details.open;
    }, true);

    root.addEventListener('input', function (event) {
      var input = event.target.closest('[data-quantity-color]');
      if (!input) return;
      var inputCard = input.closest('[data-product-id]');
      var inputProduct = products.find(function (item) { return item.productId === inputCard.dataset.productId; });
      if (!inputProduct) return;
      var value = Math.max(0, Math.min(999, Math.floor(Number(input.value) || 0)));
      input.value = value || '';
      var sizes = productDraft(inputProduct).colors[input.dataset.quantityColor].sizes;
      if (value) sizes[input.dataset.quantitySize] = value;
      else delete sizes[input.dataset.quantitySize];
      var addButton = inputCard.querySelector('[data-add-product]');
      if (addButton) addButton.disabled = configuredQuantity(productDraft(inputProduct)) === 0;
    });

    root.addEventListener('error', function (event) {
      if (event.target && event.target.matches('[data-product-image]')) imageUnavailable(event.target);
    }, true);

    tray.addEventListener('click', function (event) {
      var edit = event.target.closest('[data-edit-product]');
      if (edit) {
        var editItem = selected[edit.dataset.editProduct];
        if (!editItem) return;
        activeCategory = 'all';
        search.value = editItem.product.style;
        renderFilters();
        renderProducts();
        var editCard = grid.querySelector('[data-product-id="' + edit.dataset.editProduct + '"]');
        if (editCard) { editCard.scrollIntoView({ behavior: 'smooth', block: 'start' }); editCard.querySelector('[data-add-product]').focus({ preventScroll: true }); }
        return;
      }
      var remove = event.target.closest('[data-remove-product]');
      if (!remove) return;
      var productId = remove.dataset.removeProduct;
      delete selected[productId];
      delete drafts[productId];
      renderProducts();
      renderTray();
      restoreProductFocus(productId);
      announce(labels.selectionRemoved);
    });

    search.addEventListener('input', renderProducts);
    fetch(root.dataset.catalogUrl, { headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('catalog unavailable'); return response.json(); })
      .then(function (payload) {
        products = governedProducts(payload);
        count.textContent = products.length;
        render();
      })
      .catch(function () {
        grid.innerHTML = '<p class="favorites-catalog__status">' + escapeHtml(labels.error) + '</p>';
        filters.innerHTML = '';
        count.textContent = '—';
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stb-smartkits"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const PRODUCTS = { singlet:'Singlet', quarter:'Quarter-zip', full:'Full-zip', shorts:'Practice shorts', pants:'Warmup pants', basketball:'Sleeveless jersey', soccer:'Short-sleeve jersey',hockey:'Hockey jersey',baseball_button:'Button-up jersey',baseball_pullover:'Pullover jersey',baseball_pants:'Baseball / softball pants',volleyball_short:'Short-sleeve jersey',volleyball_sleeveless:'Sleeveless jersey',volleyball_long:'Long-sleeve jersey',running_top:'Racing top',running_shorts:'Running shorts',football_jersey:'Football jersey',football_pants:'Football pants' };
  const SPORTS = {wrestling:['singlet','quarter','full','shorts','pants'],basketball:['basketball','shorts','quarter','full','pants'],soccer:['soccer','shorts','quarter'],"hockey":["hockey", "quarter", "full", "pants"],"baseball":["baseball_button", "baseball_pullover", "baseball_pants", "quarter", "full"],"softball":["baseball_button", "baseball_pullover", "baseball_pants", "quarter", "full"],"volleyball":["volleyball_short", "volleyball_sleeveless", "volleyball_long", "shorts", "quarter", "pants"],"lacrosse":["basketball", "soccer", "shorts", "quarter", "pants"],"track":["running_top", "running_shorts", "quarter", "pants"],"cross-country":["running_top", "running_shorts", "quarter", "pants"],"football":["football_jersey", "football_pants", "shorts", "quarter", "full", "pants"]};

  const JERSEYS = ['basketball','soccer','hockey','baseball_button','baseball_pullover','volleyball_short','volleyball_sleeveless','volleyball_long','running_top','football_jersey'];
  const SHORTS = ['shorts','running_shorts'];
  const PANTS = ['pants','baseball_pants','football_pants'];
  const sleeveless = product => ['basketball','volleyball_sleeveless','running_top'].includes(product);
  const longSleeve = product => ['hockey','volleyball_long'].includes(product);
  function neckLine(product,side) {
    if(product==='football_jersey')return side==='back'?'M176 64 Q200 78 224 64':'M176 64 Q181 82 200 96 Q219 82 224 64';
    return side==='back'?'M164 64 Q200 84 236 64':['basketball','hockey','baseball_button','baseball_pullover'].includes(product)?'M164 64 Q173 91 200 108 Q227 91 236 64':'M164 64 Q200 114 236 64';
  }
  function jerseyHem(product) { return product==='football_jersey'?410:product==='hockey'?401:product==='baseball_button'||product==='baseball_pullover'?396:390; }
  function sportTrim(d,side) {
    const product=d.product, hem=jerseyHem(product);
    const neck=`<path data-trim="neck" d="${neckLine(product,side)}" fill="none" stroke="${d.colors.neck}" stroke-width="7"/>`;
    const arm=sleeveless(product)?'M116 78 Q128 126 108 177 M284 78 Q272 126 292 177':longSleeve(product)?'M40 365 L89 376 M311 376 L360 365':product==='football_jersey'?'M55 177 L105 193 M295 193 L345 177':'M45 188 Q68 204 99 211 M301 211 Q332 204 355 188';
    const construction=product==='football_jersey'?'M110 88 Q129 120 117 170 M290 88 Q271 120 283 170':product==='soccer'?'M164 64 Q117 90 112 177 M236 64 Q283 90 288 177':!sleeveless(product)?'M100 89 Q117 129 112 177 M300 89 Q283 129 288 177':'';
    const buttons=product==='baseball_button'&&side==='front'?`<path d="M196 107V402 M204 107V402" stroke="${d.colors.neck}" fill="none" stroke-width="1.4"/>${[127,176,225,274,323,372].map(y=>`<circle cx="200" cy="${y}" r="2.6" fill="${d.colors.neck}"/>`).join('')}`:'';
    return neck+`<path data-trim="arm" d="${arm}" fill="none" stroke="${d.colors.arm}" stroke-width="7"/><path d="${construction} M110 ${hem-9} Q200 ${hem} 290 ${hem-9}" fill="none" stroke="#172821" stroke-opacity=".38" stroke-width="1.2"/>`+buttons;
  }
  function fabricDetail(d,id,side) {
    if(!JERSEYS.includes(d.product)) return '';
    const hem=jerseyHem(d.product);
    return `<defs><linearGradient id="${id}-cloth"><stop stop-color="#000" stop-opacity=".12"/><stop offset=".25" stop-color="#fff" stop-opacity=".025"/><stop offset=".65" stop-color="#fff" stop-opacity=".045"/><stop offset="1" stop-color="#000" stop-opacity=".11"/></linearGradient></defs><path d="${outline(d.product,side)}" fill="url(#${id}-cloth)"/><path d="M119 191 Q138 218 121 266 Q126 216 119 191 M279 198 Q262 232 282 282 Q270 236 279 198 M145 ${hem} Q156 ${hem-48} 147 ${hem-77} Q167 ${hem-39} 159 ${hem} M250 ${hem} Q244 ${hem-57} 253 ${hem-91} Q252 ${hem-37} 267 ${hem}" fill="#000" opacity=".07"/><path d="M126 199 Q143 224 130 258 M269 295 Q266 333 275 360" fill="none" stroke="#fff" stroke-opacity=".12" stroke-width="3"/>`;
  }
  const sportKey = sport => sport === 'wrestling' ? 'stb-kit-v2' : 'stb-kit-v2:' + sport;
  const DESIGNS = { classic:'Classic', velocity:'Velocity', summit:'Summit', podium:'Podium', contour:'Contour', fade:'Fade' };
  const DESIGN_NAMES = {...DESIGNS,blank:'Blank / Freeform',terrain:'Terrain (retired)',heritage:'Heritage (retired)'};
  const FAMILY_NOTES = {blank:'A clean base for your colors, lettering and uploaded artwork.',podium:'A bold team band with balanced shoulder and hem accents.',contour:'Curved panels and flowing lines frame your team identity.',classic:'Clean panels and parallel stripes.',velocity:'Sweeping angles with a fine accent line.',summit:'Bold chevrons and balanced color blocks.',terrain:'Original camouflage with quiet space for your team.',heritage:'Stars and athletic bands in your team colors.',fade:'A smooth color fade with a crisp accent stripe.'};
  const esc = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const clamp = (value, min, max, fallback) => Number.isFinite(Number(value)) ? Math.max(min, Math.min(max, Number(value))) : fallback;
  const color = (value, fallback) => /^#[0-9a-f]{6}$/i.test(value || '') ? value : fallback;
  // Original vector artwork supplied by STB, extracted from STB_WRESTLING_BEANIE.ai.
  const STB_LOGO = `<path d="M 21.714844 126.589844 L 21.714844 20.882812 C 21.714844 15.546875 25.632812 11.125 30.734375 10.328125 L 25.597656 10.328125 C 20.523438 10.328125 16.410156 14.386719 16.410156 19.386719 L 16.410156 128.101562 C 16.410156 133.101562 20.523438 137.160156 25.597656 137.160156 L 30.8125 137.160156 C 25.675781 136.398438 21.714844 131.953125 21.714844 126.589844 " fill-rule="nonzero"/><path d="M 272.265625 89.179688 C 268.527344 88.746094 265.363281 90.128906 265.363281 90.128906 C 265.363281 90.128906 260.867188 92.851562 262.035156 90.605469 C 265.125 84.65625 265.363281 80.136719 265.363281 80.136719 C 265.363281 80.136719 273.929688 81.089844 274.167969 82.277344 C 274.757812 85.230469 282.261719 91.320312 282.261719 91.320312 C 282.261719 91.320312 278.453125 89.890625 272.265625 89.179688 M 243.949219 66.8125 C 241.09375 66.574219 240.855469 66.574219 240.855469 66.574219 C 240.855469 66.574219 238.207031 66.65625 238.476562 63.957031 C 238.714844 61.578125 234.195312 56.34375 234.195312 56.34375 C 242.046875 64.195312 244.664062 64.90625 244.664062 64.90625 C 244.664062 64.90625 248.21875 67.167969 243.949219 66.8125 M 289.414062 10.539062 L 284.195312 10.539062 C 289.335938 11.300781 293.296875 15.742188 293.296875 21.105469 L 293.296875 85.613281 L 293.203125 85.609375 C 291.777344 79.183594 286.78125 73.234375 286.78125 73.234375 C 286.78125 73.234375 284.878906 64.667969 281.070312 61.578125 C 277.261719 58.484375 271.550781 58.960938 270.125 56.820312 C 268.695312 54.675781 256.324219 39.6875 250.375 38.019531 C 246.433594 36.914062 238.476562 35.878906 238.476562 35.878906 L 237.289062 34.925781 C 237.289062 34.925781 236.097656 31.832031 236.335938 30.167969 C 236.574219 28.5 235.148438 24.695312 234.195312 23.027344 C 233.242188 21.363281 231.339844 19.460938 225.867188 19.9375 C 220.132812 20.433594 218.730469 25.882812 218.730469 25.882812 C 218.730469 25.882812 217.0625 29.453125 218.25 34.214844 C 218.898438 36.792969 223.960938 40.636719 223.960938 40.636719 C 220.632812 43.730469 221.347656 49.679688 221.347656 49.679688 C 221.347656 49.679688 213.253906 48.726562 212.066406 48.25 C 210.875 47.773438 208.253906 45.320312 205.402344 44.445312 C 202.308594 43.492188 197.3125 44.921875 197.3125 44.921875 C 197.3125 44.921875 192.507812 45.0625 191.363281 45.632812 C 188.984375 46.824219 188.03125 49.441406 187.316406 50.394531 C 186.601562 51.34375 182.082031 54.914062 182.082031 54.914062 C 182.082031 54.914062 180.417969 56.820312 179.941406 59.199219 C 179.464844 61.578125 175.660156 68.714844 175.660156 68.714844 C 175.660156 68.714844 175.660156 70.378906 176.847656 73.234375 C 178.039062 76.089844 180.417969 73.949219 180.417969 73.949219 C 180.417969 73.949219 178.039062 78.234375 177.324219 80.375 C 176.609375 82.515625 176.847656 87.988281 176.847656 87.988281 C 176.847656 87.988281 177.796875 89.890625 177.324219 90.84375 C 176.847656 91.796875 175.105469 97.726562 174.945312 98.695312 C 173.992188 104.410156 175.421875 108.453125 175.421875 109.878906 C 175.421875 111.308594 177.085938 114.640625 177.085938 115.589844 C 177.085938 116.542969 176.152344 116.859375 176.609375 119.160156 C 177.085938 121.539062 177.324219 125.585938 177.324219 125.585938 C 177.324219 125.585938 180.179688 127.011719 191.839844 125.585938 C 192.78125 125.46875 194.433594 123.917969 195.628906 123.679688 C 196.816406 123.441406 196.578125 122.253906 196.578125 122.253906 L 193.960938 120.824219 C 193.960938 120.824219 193.980469 121.777344 191.363281 121.539062 C 188.742188 121.300781 187.554688 117.257812 187.554688 117.257812 L 185.414062 114.875 L 187.316406 101.078125 C 187.316406 101.078125 188.03125 95.839844 190.410156 96.316406 C 192.789062 96.792969 199.214844 95.839844 199.214844 95.839844 L 206.59375 102.742188 L 202.785156 102.503906 C 202.785156 102.503906 199.929688 103.214844 198.976562 103.457031 C 198.027344 103.695312 197.550781 106.308594 197.550781 107.261719 C 197.550781 108.214844 201.121094 112.734375 201.832031 112.972656 C 202.546875 113.210938 206.832031 118.683594 208.734375 122.253906 C 210.636719 125.820312 218.132812 127.011719 218.964844 126.773438 C 219.800781 126.539062 221.105469 125.109375 221.582031 123.917969 C 222.058594 122.730469 221.347656 121.0625 221.347656 121.0625 L 226.105469 122.96875 C 226.105469 122.96875 228.246094 123.917969 231.816406 123.679688 C 235.382812 123.441406 234.433594 117.96875 234.433594 117.96875 L 229.195312 104.410156 L 220.632812 89.417969 C 220.632812 89.417969 216.585938 85.132812 217.0625 81.800781 C 217.539062 78.46875 224.914062 77.757812 224.914062 77.757812 C 224.914062 77.757812 226.578125 80.375 226.816406 81.089844 C 227.054688 81.800781 228.960938 86.085938 228.960938 86.085938 C 228.960938 86.085938 230.148438 89.890625 230.625 90.605469 C 231.101562 91.320312 233.242188 94.890625 233.242188 94.890625 C 233.242188 94.890625 233.957031 98.457031 234.195312 99.410156 C 234.433594 100.363281 235.859375 106.785156 235.859375 106.785156 L 236.335938 109.878906 L 237.050781 111.78125 C 237.050781 111.78125 239.429688 113.6875 240.140625 114.164062 C 240.855469 114.640625 241.09375 113.6875 241.09375 113.6875 L 240.382812 111.78125 L 239.667969 109.878906 L 243 111.546875 C 243 111.546875 244.664062 113.449219 245.140625 114.875 C 245.613281 116.304688 247.996094 118.210938 247.996094 118.210938 L 248.945312 117.730469 C 248.945312 117.730469 247.28125 112.5 247.042969 111.546875 C 246.804688 110.59375 241.570312 104.882812 241.570312 104.882812 L 241.09375 100.839844 C 241.09375 100.839844 240.382812 94.890625 240.382812 93.9375 C 240.382812 92.984375 240.621094 89.890625 239.90625 86.796875 C 239.742188 86.101562 238.238281 82.992188 238.238281 82.992188 L 237.765625 78.707031 L 238.238281 74.425781 L 238.238281 71.332031 L 243.472656 72.761719 L 249.660156 73.710938 C 249.660156 73.710938 243.710938 81.800781 244.1875 98.457031 C 244.296875 102.292969 248.707031 102.503906 251.800781 102.742188 C 254.894531 102.980469 260.84375 102.265625 265.839844 101.078125 C 270.835938 99.886719 279.640625 98.933594 279.640625 98.933594 L 281.070312 103.214844 C 281.070312 103.214844 278.929688 107.976562 277.738281 107.976562 C 276.550781 107.976562 276.789062 110.117188 276.789062 110.117188 C 276.789062 110.117188 277.738281 110.59375 280.355469 110.832031 C 282.972656 111.070312 286.78125 106.550781 286.78125 106.550781 C 286.78125 106.550781 286.78125 101.078125 287.257812 100.363281 C 287.734375 99.648438 289.160156 97.269531 289.160156 97.269531 L 293.296875 97.332031 L 293.296875 126.8125 C 293.296875 132.148438 289.375 136.570312 284.273438 137.367188 L 289.414062 137.367188 C 294.484375 137.367188 298.597656 133.3125 298.597656 128.308594 L 298.597656 19.597656 C 298.597656 14.59375 294.484375 10.539062 289.414062 10.539062 " fill-rule="nonzero"/><path d="M 45.140625 120.789062 L 128.855469 120.765625 L 132.101562 123.347656 L 42.226562 123.347656 Z M 45.140625 120.789062 " fill-rule="nonzero"/><path d="M 128.859375 106.179688 L 45.472656 106.226562 L 42.226562 103.640625 L 132.101562 103.640625 Z M 128.859375 106.179688 " fill-rule="nonzero"/><path d="M 51.515625 110.34375 L 47.875 110.34375 L 47.875 112.394531 L 51.339844 112.394531 C 51.875 112.394531 52.238281 112.550781 52.4375 112.859375 C 52.632812 113.167969 52.730469 113.769531 52.730469 114.664062 L 52.730469 115.976562 C 52.730469 116.871094 52.632812 117.472656 52.4375 117.78125 C 52.238281 118.089844 51.875 118.246094 51.339844 118.246094 L 47.914062 118.246094 C 47.386719 118.246094 47.023438 118.089844 46.824219 117.78125 C 46.625 117.472656 46.527344 116.871094 46.527344 115.980469 L 46.527344 115.71875 L 47.667969 115.3125 L 47.667969 116.441406 L 51.589844 116.441406 L 51.589844 114.253906 L 48.132812 114.253906 C 47.601562 114.253906 47.242188 114.097656 47.046875 113.785156 C 46.851562 113.476562 46.753906 112.875 46.753906 111.988281 L 46.753906 110.933594 C 46.753906 110.042969 46.851562 109.445312 47.046875 109.136719 C 47.242188 108.828125 47.601562 108.671875 48.132812 108.671875 L 51.28125 108.671875 C 51.789062 108.671875 52.144531 108.820312 52.351562 109.113281 C 52.554688 109.414062 52.65625 109.964844 52.65625 110.765625 L 52.65625 110.96875 L 51.515625 111.433594 Z M 51.515625 110.34375 " fill-rule="nonzero"/><path d="M 57.996094 110.382812 L 57.996094 118.246094 L 56.699219 118.246094 L 56.699219 110.382812 L 54.148438 110.382812 L 54.148438 108.671875 L 60.546875 108.671875 L 60.546875 110.382812 Z M 57.996094 110.382812 " fill-rule="nonzero"/><path d="M 66.292969 110.320312 L 63.398438 110.320312 L 63.398438 112.988281 L 66.292969 112.988281 C 66.496094 112.988281 66.636719 112.953125 66.714844 112.875 C 66.820312 112.769531 66.875 112.550781 66.875 112.230469 L 66.875 111.082031 C 66.875 110.753906 66.820312 110.542969 66.714844 110.429688 C 66.636719 110.355469 66.496094 110.320312 66.292969 110.320312 M 62.125 118.246094 L 62.125 108.671875 L 66.878906 108.671875 C 67.707031 108.671875 68.125 109.289062 68.125 110.527344 L 68.125 112.769531 C 68.125 114.007812 67.707031 114.625 66.878906 114.625 L 66.148438 114.625 L 68.707031 118.246094 L 66.855469 118.246094 L 64.625 114.625 L 63.398438 114.625 L 63.398438 118.246094 Z M 62.125 118.246094 " fill-rule="nonzero"/><path d="M 70.746094 108.671875 L 72.039062 108.671875 L 72.039062 118.246094 L 70.746094 118.246094 Z M 70.746094 108.671875 " fill-rule="nonzero"/><path d="M 76.742188 118.246094 L 73.539062 108.671875 L 75.011719 108.671875 L 77.257812 115.589844 L 79.398438 108.671875 L 80.6875 108.671875 L 77.636719 118.246094 Z M 76.742188 118.246094 " fill-rule="nonzero"/><path d="M 82.191406 118.246094 L 82.191406 108.671875 L 87.871094 108.671875 L 87.871094 110.308594 L 83.488281 110.308594 L 83.488281 112.429688 L 86.042969 112.429688 L 86.042969 114.066406 L 83.488281 114.066406 L 83.488281 116.441406 L 87.921875 116.441406 L 87.921875 118.246094 Z M 82.191406 118.246094 " fill-rule="nonzero"/><path d="M 89.40625 112.34375 L 91.910156 112.34375 L 91.910156 114.261719 L 89.40625 114.261719 Z M 89.40625 112.34375 " fill-rule="nonzero"/><path d="M 96.441406 110.382812 L 96.441406 118.246094 L 95.148438 118.246094 L 95.148438 110.382812 L 92.597656 110.382812 L 92.597656 108.671875 L 98.988281 108.671875 L 98.988281 110.382812 Z M 96.441406 110.382812 " fill-rule="nonzero"/><path d="M 101.746094 116.441406 L 106 116.441406 L 106 110.382812 L 101.746094 110.382812 Z M 100.457031 110.9375 C 100.457031 110.042969 100.554688 109.445312 100.746094 109.136719 C 100.9375 108.828125 101.300781 108.671875 101.832031 108.671875 L 105.914062 108.671875 C 106.445312 108.671875 106.808594 108.828125 107.003906 109.136719 C 107.195312 109.445312 107.292969 110.042969 107.292969 110.9375 L 107.292969 115.980469 C 107.292969 116.871094 107.195312 117.472656 107.003906 117.78125 C 106.808594 118.089844 106.445312 118.246094 105.914062 118.246094 L 101.832031 118.246094 C 101.300781 118.246094 100.9375 118.089844 100.746094 117.78125 C 100.554688 117.472656 100.457031 116.871094 100.457031 115.980469 Z M 100.457031 110.9375 " fill-rule="nonzero"/><path d="M 109.105469 112.34375 L 111.613281 112.34375 L 111.613281 114.261719 L 109.105469 114.261719 Z M 109.105469 112.34375 " fill-rule="nonzero"/><path d="M 117.769531 114.085938 L 114.828125 114.085938 L 114.828125 116.519531 L 117.769531 116.519531 C 117.984375 116.519531 118.132812 116.476562 118.21875 116.390625 C 118.335938 116.265625 118.390625 116.027344 118.390625 115.667969 L 118.390625 114.941406 C 118.390625 114.585938 118.335938 114.339844 118.21875 114.214844 C 118.132812 114.132812 117.984375 114.085938 117.769531 114.085938 M 117.769531 110.230469 L 114.828125 110.230469 L 114.828125 112.515625 L 117.769531 112.515625 C 118.164062 112.515625 118.359375 112.285156 118.359375 111.828125 L 118.359375 110.917969 C 118.359375 110.464844 118.164062 110.230469 117.769531 110.230469 M 113.554688 118.246094 L 113.554688 108.671875 L 118.308594 108.671875 C 119.136719 108.671875 119.554688 109.289062 119.554688 110.527344 L 119.554688 111.695312 C 119.554688 112.636719 119.234375 113.175781 118.597656 113.3125 C 119.261719 113.460938 119.597656 114.070312 119.597656 115.144531 L 119.597656 116.375 C 119.597656 117.617188 119.050781 118.246094 117.964844 118.246094 Z M 113.554688 118.246094 " fill-rule="nonzero"/><path d="M 122.089844 118.246094 L 122.089844 108.671875 L 127.765625 108.671875 L 127.765625 110.308594 L 123.382812 110.308594 L 123.382812 112.429688 L 125.9375 112.429688 L 125.9375 114.066406 L 123.382812 114.066406 L 123.382812 116.441406 L 127.820312 116.441406 L 127.820312 118.246094 Z M 122.089844 118.246094 " fill-rule="nonzero"/><path d="M 130.492188 83.667969 C 130.492188 88.730469 129.082031 92.148438 126.269531 93.90625 C 123.460938 95.667969 118.269531 96.546875 110.707031 96.546875 L 65.246094 96.546875 C 64.03125 96.539062 62.933594 96.507812 61.882812 96.472656 L 55.996094 96.472656 C 51.902344 96.472656 49.105469 95.996094 47.609375 95.042969 C 46.117188 94.085938 45.371094 92.234375 45.371094 89.484375 L 45.371094 86.222656 L 45.460938 62.859375 L 61.71875 60.515625 L 61.71875 76.132812 L 61.816406 76.136719 L 61.816406 79.402344 C 61.816406 82.152344 62.566406 84.003906 64.058594 84.957031 C 65.210938 85.691406 67.148438 86.140625 69.859375 86.308594 L 105.980469 86.308594 C 108.6875 86.140625 110.621094 85.691406 111.777344 84.957031 C 113.273438 84.003906 114.015625 82.152344 114.015625 79.402344 L 114.015625 76.136719 L 114.230469 76.125 L 114.230469 59.378906 C 114.011719 57.382812 113.296875 55.980469 112.070312 55.199219 C 110.609375 54.265625 107.898438 53.789062 103.957031 53.769531 L 64.898438 53.769531 C 57.339844 53.769531 52.183594 52.890625 49.425781 51.125 C 46.667969 49.367188 45.289062 45.953125 45.289062 40.878906 L 45.289062 34.855469 C 45.289062 29.78125 46.667969 26.363281 49.425781 24.605469 C 52.183594 22.84375 57.339844 21.960938 64.898438 21.960938 L 109.785156 21.960938 C 117.035156 21.960938 122.117188 22.804688 125.03125 24.492188 C 127.9375 26.175781 129.394531 27.925781 129.394531 32.496094 L 129.394531 33.65625 L 113.136719 36.292969 L 113.136719 36.015625 C 112.929688 34.300781 112.207031 33.882812 110.957031 33.085938 C 109.460938 32.128906 106.664062 31.65625 102.570312 31.65625 L 71.625 31.65625 C 67.527344 31.65625 64.734375 32.128906 63.238281 33.085938 C 62.335938 33.660156 61.710938 34.574219 61.351562 35.800781 L 61.351562 38.152344 C 61.628906 39.898438 62.328125 41.132812 63.457031 41.855469 C 64.570312 42.5625 66.40625 43.007812 68.957031 43.191406 L 110.714844 43.191406 C 118.28125 43.191406 123.464844 44.070312 126.277344 45.832031 C 129.085938 47.589844 130.492188 51 130.492188 56.070312 Z M 128.328125 44.273438 C 124.90625 42.128906 119.140625 41.085938 110.714844 41.085938 L 69.144531 41.085938 C 66.703125 40.902344 65.804688 40.488281 65.535156 40.3125 C 65.28125 40.148438 64.675781 39.605469 64.402344 38.019531 L 64.402344 36.039062 C 64.714844 35.097656 65.140625 34.738281 65.3125 34.625 C 65.722656 34.363281 67.15625 33.753906 71.625 33.753906 L 102.570312 33.753906 C 107.035156 33.753906 108.46875 34.363281 108.882812 34.625 C 108.882812 34.625 108.980469 34.6875 108.980469 34.6875 C 109.933594 35.296875 109.984375 35.335938 110.082031 36.105469 L 110.082031 38.949219 L 132.445312 35.320312 L 132.445312 32.496094 C 132.445312 27.730469 131.019531 25.214844 126.996094 22.882812 C 123.484375 20.847656 117.855469 19.859375 109.785156 19.859375 L 64.898438 19.859375 C 56.464844 19.859375 50.726562 20.910156 47.347656 23.0625 C 43.910156 25.261719 42.238281 29.113281 42.238281 34.855469 L 42.238281 40.878906 C 42.238281 46.617188 43.910156 50.472656 47.351562 52.667969 C 50.722656 54.824219 56.460938 55.871094 64.898438 55.871094 L 103.957031 55.871094 C 108.21875 55.894531 109.597656 56.484375 109.992188 56.738281 C 110.277344 56.917969 110.953125 57.554688 111.179688 59.480469 L 111.179688 74.1875 C 111.148438 74.1875 110.964844 74.199219 110.964844 74.199219 L 110.964844 79.402344 C 110.964844 82.375 110 83.226562 109.703125 83.410156 C 109.414062 83.59375 108.464844 84.03125 105.808594 84.207031 L 70.023438 84.207031 C 67.371094 84.03125 66.417969 83.59375 66.132812 83.414062 C 65.835938 83.222656 64.867188 82.375 64.867188 79.402344 L 64.867188 74.1875 C 64.867188 74.1875 64.777344 74.183594 64.773438 74.183594 L 64.773438 57.925781 L 42.414062 61.152344 L 42.316406 86.21875 L 42.316406 89.484375 C 42.316406 92.878906 43.367188 95.199219 45.539062 96.582031 C 47.632812 97.921875 51.054688 98.574219 55.996094 98.574219 L 61.851562 98.574219 C 62.078125 98.578125 65.210938 98.644531 65.210938 98.644531 L 110.707031 98.644531 C 119.132812 98.644531 124.902344 97.605469 128.324219 95.460938 C 131.835938 93.261719 133.542969 89.40625 133.542969 83.667969 L 133.542969 56.070312 C 133.542969 50.328125 131.835938 46.472656 128.328125 44.273438 " fill-rule="nonzero"/><path d="M 157.957031 126.804688 L 152.96875 126.804688 L 152.96875 19.863281 L 157.957031 19.863281 Z M 157.957031 126.804688 " fill-rule="nonzero"/>`;
  // Each tuple is center X, center Y, width. Keep the full mark inside one panel.
  const LOGO_LAYOUTS = {
    classic: {singlet:[200,183,96],quarter:[245,134,54],full:[245,134,54],shorts:[252,216,50],pants:[237,157,40]},
    velocity:{singlet:[200,181,94],quarter:[246,132,58],full:[246,132,58],shorts:[251,199,54],pants:[246,157,48]},
    summit:  {singlet:[200,178,90],quarter:[244,124,54],full:[244,124,54],shorts:[260,335,54],pants:[248,157,50]},
    podium:  {singlet:[200,212,88],quarter:[246,130,58],full:[246,130,58],shorts:[254,221,58],pants:[248,157,50]},
    contour: {singlet:[200,184,48],quarter:[246,135,58],full:[246,135,58],shorts:[281,275,64,90],pants:[274,218,64,90]},
    fade:    {singlet:[200,180,94],quarter:[243,130,56],full:[243,130,56],shorts:[247,210,46],pants:[243,157,46]},
    blank:   {singlet:[200,183,98],quarter:[250,135,60],full:[250,135,60],shorts:[255,230,58],pants:[252,157,55]}
  };
  function logoPlacement(product, design='velocity', side='front') {
    if(design==='classic' && ['quarter','full'].includes(product) && side==='back') return {logoX:200,logoY:103,logoSize:34,logoRotation:0};
    if(['baseball_pants','football_pants'].includes(product)) return {logoX:251,logoY:130,logoSize:42,logoRotation:0};
    if(product==='running_shorts') return {logoX:257,logoY:218,logoSize:36,logoRotation:0};
    if(sleeveless(product)) return {logoX:200,logoY:design==='podium'?207:155,logoSize:design==='contour'?48:64,logoRotation:0};
    if(JERSEYS.includes(product)) return {logoX:side==='back'?150:250,logoY:125,logoSize:44,logoRotation:0};
    const [x,y,size,rotation=0]=(LOGO_LAYOUTS[design] || LOGO_LAYOUTS.blank)[product];
    return {logoX:side==='back'?400-x:x,logoY:y,logoSize:size,logoRotation:rotation};
  }
  function designLogoPlacement(d,side) {
    if(d.artworkVersion===2&&JERSEYS.includes(d.product))return {logoX:side==='front'?259:200,logoY:side==='front'?115:291,logoSize:side==='front'?28:42,logoRotation:0};
    return logoPlacement(d.product,d.design,side);
  }
  function logoInk(d,v) {
    const onSecondary=(d.design==='classic' && ['quarter','full'].includes(d.product)) || (d.design==='summit' && ['singlet','quarter','full'].includes(d.product)) || (d.design==='podium' && d.product==='singlet') || (d.design==='contour' && ['pants','shorts'].includes(d.product) && v.logoRotation===90);
    return color(v.logoColor,onSecondary ? d.colors.primary : d.colors.accent);
  }
  function localLogo(d,side) {
    const v=d.views[side];
    return v.defaultLogo && !v.logo && v.logoAuto ? {...v,...designLogoPlacement(d,side)} : v;
  }
  // Sample the actual flat outline at the logo's height to locate its side seams.
  function seamBounds(product,y) {
    const tokens=outline(product,'front').match(/[MLQCZ]|-?\d+(?:\.\d+)?/g);
    const points=[]; let i=0,x=0,z=0,start;
    while(i<tokens.length) {
      const cmd=tokens[i++],n=cmd==='C'?6:cmd==='Q'?4:cmd==='Z'?0:2;
      const v=tokens.slice(i,i+n).map(Number); i+=n;
      if(cmd==='M'){x=v[0];z=v[1];start=[x,z];points.push(start);continue;}
      if(cmd==='Z'){points.push(start);continue;}
      const ox=x,oy=z;
      for(let k=1;k<=48;k++){const t=k/48,u=1-t;
        points.push(cmd==='C'?[u*u*u*ox+3*u*u*t*v[0]+3*u*t*t*v[2]+t*t*t*v[4],u*u*u*oy+3*u*u*t*v[1]+3*u*t*t*v[3]+t*t*t*v[5]]:cmd==='Q'?[u*u*ox+2*u*t*v[0]+t*t*v[2],u*u*oy+2*u*t*v[1]+t*t*v[3]]:[ox+(v[0]-ox)*t,oy+(v[1]-oy)*t]);}
      [x,z]=points[points.length-1];
    }
    const crossings=[];
    for(let k=1;k<points.length;k++){const [ax,ay]=points[k-1],[bx,by]=points[k];if((ay<=y&&by>y)||(by<=y&&ay>y))crossings.push(ax+(y-ay)*(bx-ax)/(by-ay));}
    return crossings.length>=2?[Math.min(...crossings),Math.max(...crossings)]:null;
  }
  function viewLogo(d,side) {
    const own=localLogo(d,side),source=d.wrapSource;
    if(!source || source===side)return own;
    const v=localLogo(d,source),edges=seamBounds(d.product,v.logoY);
    if(!edges || !(v.logo||v.defaultLogo))return own;
    const [left,right]=edges,half=v.logoSize/2;
    const shift=v.logoX<200&&v.logoX-half<left?right-left:v.logoX>=200&&v.logoX+half>right?left-right:0;
    return shift?{...own,logo:v.logo,defaultLogo:v.defaultLogo,logoAuto:false,logoX:v.logoX+shift,logoY:v.logoY,logoSize:v.logoSize,logoRotation:v.logoRotation,logoColor:logoInk(d,v)}:own;
  }
  const defaults = () => ({ version:1, product:'singlet', design:'velocity', pinstripe:{enabled:false,color:'#ffffff'}, colors:{primary:'#111111',secondary:'#b8f36d',accent:'#ffffff',neck:'#ffffff',arm:'#ffffff',cuff:'#ffffff',waistband:'#111111',ankle:'#111111'}, views:{front:{text:'',defaultLogo:true,logoAuto:true,logoRotation:0,logoColor:'',textColor:'#ffffff',textX:200,textY:215,textSize:23,logo:'',logoX:200,logoY:150,logoSize:65},back:{text:'',defaultLogo:false,logoAuto:true,logoRotation:0,logoColor:'',textColor:'#ffffff',textX:200,textY:195,textSize:22,logo:'',logoX:200,logoY:265,logoSize:65}},notes:'' });
  function numberDefaults(product,side) {
    const both=['basketball','football_jersey','volleyball_short','volleyball_sleeveless','volleyball_long'];
    const backOnly=['soccer','hockey','baseball_button','baseball_pullover'];
    if(!both.includes(product)&&!(side==='back'&&backOnly.includes(product))) return null;
    return {text:'12',textX:200,textY:side==='back'?218:225,textSize:product.startsWith('volleyball')?68:84};
  }
  function seedNumbers(d,previousProduct) {
    if(d.artworkVersion===2){
      for(const side of ['front','back']){const v=d.views[side],preset=numberDefaults(d.product,side);
        if(preset&&v.number===undefined&&/^\d{1,3}$/.test(v.text)){Object.assign(v,{number:v.text,numberX:v.textX,numberY:v.textY,numberSize:v.textSize,numberColor:v.textColor,text:''});}
        if(previousProduct&&v.number==='12'&&!numberDefaults(d.product,side))v.number='';
        if(preset&&(v.number===undefined||(previousProduct&&!numberDefaults(previousProduct,side)&&v.number===''))){v.number='12';v.numberX=200;v.numberY=preset.textY;v.numberSize=preset.textSize;v.numberColor=v.textColor;}
        if(JERSEYS.includes(d.product)&&!v.text){v.text=side==='front'?'TEAM':'PLAYER';v.textY=126;v.textSize=18;}
        if(!JERSEYS.includes(d.product)&&['TEAM','PLAYER'].includes(v.text))v.text='';
      }return d;
    }
    for(const side of ['front','back']) {
      const v=d.views[side],old=numberDefaults(previousProduct,side);
      if(old&&Object.entries(old).every(([k,value])=>v[k]===value)) Object.assign(v,{text:'',textSize:23});
      const starter=numberDefaults(d.product,side);
      if(starter&&!v.text) Object.assign(v,starter);
    }
    return d;
  }
  function normalize(raw) {
    if (!raw || raw.version !== 1 || !PRODUCTS[raw.product] || !DESIGN_NAMES[raw.design]) throw new Error('Choose an STB design file created by this studio.');
    const d = defaults();
    d.product = raw.product; d.design = raw.design;
    if(raw.artworkVersion!==undefined){if(raw.artworkVersion!==2||!Object.hasOwn(SPORTS,raw.sportProfile))throw new Error('This artwork version is not supported.');d.artworkVersion=2;d.sportProfile=raw.sportProfile;}
    d.pinstripe = {enabled:raw.pinstripe?.enabled===true,color:color(raw.pinstripe?.color,'#ffffff')};
    for (const key of Object.keys(d.colors)) d.colors[key] = color(raw.colors?.[key], ['waistband','ankle'].includes(key) ? color(raw.colors?.primary,d.colors[key]) : ['neck','arm','cuff'].includes(key) ? color(raw.colors?.accent,d.colors[key]) : d.colors[key]);
    for (const side of ['front','back']) {
      const v = raw.views?.[side] || {}, target = d.views[side];
      target.text = typeof v.text === 'string' ? v.text.slice(0,24) : target.text;
      target.textColor = color(v.textColor, target.textColor);
      if(v.number!==undefined){if(typeof v.number!=='string'||!/^\d{0,3}$/.test(v.number))throw new Error('Jersey numbers must contain up to three digits.');target.number=v.number;target.numberColor=color(v.numberColor,target.textColor);for(const [key,min,max,fallback] of [['numberX',95,305,200],['numberY',90,420,218],['numberSize',30,110,84]])target[key]=clamp(v[key],min,max,fallback);}
      const legacyPlaceholder = !Object.hasOwn(v,'defaultLogo') && !v.logo && v.text === (side==='front'?'YOUR TEAM':'WRESTLING');
      target.defaultLogo = v.defaultLogo === true || (legacyPlaceholder && side==='front');
      target.logoAuto = v.logoAuto !== false;
      target.logoColor = color(v.logoColor,'');
      if(legacyPlaceholder) target.text='';
      for (const [key,min,max] of [['textX',95,305],['textY',90,420],['textSize',12,110],['logoX',-400,800],['logoY',-480,960],['logoSize',25,800],['logoRotation',-180,180]]) target[key] = clamp(v[key],min,max,target[key]);
      if (v.logo) {
        if (typeof v.logo !== 'string' || v.logo.length > 1600000 || !/^data:image\/png;base64,[A-Za-z0-9+/]+=*$/.test(v.logo)) throw new Error('The logo in this file is invalid. Upload a PNG or JPEG in the studio.');
        target.logo = v.logo;
      }
    }
    d.wrapSource = ['front','back'].includes(raw.wrapSource)?raw.wrapSource:null;
    d.notes = typeof raw.notes === 'string' ? raw.notes.slice(0,1200) : '';
    return d;
  }
  function outline(product, side) {
    if(JERSEYS.includes(product)) {
      const neck=side==='back'?'Q200 84 236 64':['basketball','hockey','baseball_button','baseball_pullover'].includes(product)?'Q173 91 200 108 Q227 91 236 64':'Q200 114 236 64';
      if(sleeveless(product)) return `M116 78 L164 64 ${neck} L284 78 Q272 126 292 177 Q282 268 294 390 Q200 400 106 390 Q118 268 108 177 Q128 126 116 78 Z`;
      if(product==='hockey') return `M164 64 ${neck} L298 85 Q324 90 332 128 L360 365 L311 376 L291 199 L301 401 Q200 411 99 401 L109 199 L89 376 L40 365 L68 128 Q76 90 102 85 Z`;
      if(product==='volleyball_long') return `M164 64 ${neck} L298 85 Q318 95 325 132 L360 365 L311 376 L286 187 Q274 273 290 390 Q200 400 110 390 Q126 273 114 187 L89 376 L40 365 L75 132 Q82 95 102 85 Z`;
      if(product==='football_jersey') return `M176 64 ${side==='back'?'Q200 78 224 64':'Q181 82 200 96 Q219 82 224 64'} L290 88 Q313 96 324 127 L345 177 L295 193 L283 170 Q274 273 286 410 Q200 422 114 410 Q126 273 117 170 L105 193 L55 177 L76 127 Q87 96 110 88 Z`;
      const hem=jerseyHem(product),tail=product.startsWith('baseball')?24:9;
      return `M164 64 ${neck} L300 89 Q324 109 333 146 L355 188 Q332 204 301 211 L288 177 Q282 283 290 ${hem} Q200 ${hem+tail} 110 ${hem} Q118 283 112 177 L99 211 Q68 204 45 188 L67 146 Q76 109 100 89 Z`;
    }
    if(product==='baseball_pants'||product==='football_pants') return 'M120 42 Q200 35 280 42 Q293 136 288 243 L278 385 Q260 395 236 385 L226 266 Q214 194 200 166 Q186 194 174 266 L164 385 Q140 395 122 385 L112 243 Q107 136 120 42 Z';
    if(product==='running_shorts') return 'M110 145 Q200 134 290 145 L311 305 Q270 327 217 316 L200 247 L183 316 Q130 327 89 305 Z';
    if (product === 'singlet') {
      const neck=side==='front'?'L164 40 C165 100 168 126 185 132 Q200 140 215 132 C232 126 235 100 236 40':'L161 44 Q167 77 200 76 Q233 77 239 44';
      return `M143 48 ${neck} L257 48 C259 95 257 128 272 153 C264 183 260 215 267 251 C276 291 290 332 291 393 L292 429 Q258 446 228 434 C224 404 214 371 208 346 Q205 335 200 335 Q195 335 192 346 C186 371 176 404 172 434 Q142 446 108 429 L109 393 C110 332 124 291 133 251 C140 215 136 183 128 153 C143 128 141 95 143 48 Z`;
    }
    if (product === 'shorts') return 'M104 145 Q200 130 296 145 L316 364 L212 378 L200 254 L188 378 L84 364 Z';
    if (product === 'pants') return 'M120 42 Q200 35 280 42 Q297 135 293 252 Q288 274 292 289 L289 388 Q289 417 278 430 L277 451 Q258 457 239 451 L238 430 Q229 417 230 388 L229 302 Q226 286 224 275 Q216 204 200 164 Q184 204 176 275 Q174 286 171 302 L170 388 Q171 417 162 430 L161 451 Q142 457 123 451 L122 430 Q111 417 111 388 L108 289 Q112 274 107 252 Q103 135 120 42 Z';
    return 'M162 25 Q200 17 238 25 Q242 53 253 62 L308 91 Q328 100 337 131 Q348 170 349 223 L356 337 Q359 378 348 402 L343 439 L306 439 L302 405 L293 398 L291 430 Q200 442 109 430 L107 398 L98 405 L94 439 L57 439 L52 402 Q41 378 44 337 L51 223 Q52 170 63 131 Q72 100 92 91 L147 62 Q158 53 162 25 Z';
  }
  const SPORT_FAMILIES = {
    football:['Clean varsity','Shoulder bars','Side rails','Two-tone yoke','Tonal armor','Lower fade'],
    baseball:['Traditional piping','Pinstripe','Contrast sleeves','Shoulder yoke','Tonal diamond','Side sweep'],
    basketball:['Varsity trim','Side rails','Pinstripe','Retro blocks','Tonal court','Lower fade'],
    soccer:['Club solid','Vertical stripes','Hoops','Diagonal sash','Tonal geometry','Soft fade'],
    hockey:['Shoulder yoke','Sleeve & hem bands','Chest band','Clean crest','Tonal ice','Angular shoulders'],
    volleyball:['Contrast sleeves','Diagonal panel','Shoulder block','Collegiate bands','Soft fade','Tonal geometry'],
    lacrosse:['Collegiate solid','Side rails','Shoulder blocks','Chest band','Tonal geometry','Diagonal accent'],
    track:['Racing solid','Side rails','Diagonal stripe','Chest band','Motion lines','Lower fade']
  };
  function familyName(d) {
    const profile=d.sportProfile==='softball'?'baseball':d.sportProfile==='cross-country'?'track':d.sportProfile;
    return d.artworkVersion===2&&SPORT_FAMILIES[profile]&&d.design!=='blank' ? SPORT_FAMILIES[profile][Object.keys(DESIGNS).indexOf(d.design)] || DESIGN_NAMES[d.design] : DESIGN_NAMES[d.design];
  }
  function sportFamilyV2(d,id,side) {
    if(d.design==='blank')return '';
    const profile=d.sportProfile==='softball'?'baseball':d.sportProfile==='cross-country'?'track':d.sportProfile;
    if(!SPORT_FAMILIES[profile])return null;
    const {primary:p,secondary:s,accent:a}=d.colors,n=Object.keys(DESIGNS).indexOf(d.design);
    const bottom=SHORTS.includes(d.product)||PANTS.includes(d.product), short=SHORTS.includes(d.product), hem=short?350:PANTS.includes(d.product)?414:jerseyHem(d.product);
    const rails=`<path d="M0 0H118L128 480H0Z M282 0H400V480H272Z" fill="${s}"/><path d="M125 0L135 480 M275 0L265 480" fill="none" stroke="${a}" stroke-width="4"/>`;
    const bands=`<path d="M0 ${hem-62}H400V${hem-35}H0Z" fill="${s}"/><path d="M0 ${hem-69}H400 M0 ${hem-27}H400" stroke="${a}" stroke-width="4"/>`;
    const sleeves=`<path d="M0 0H102Q130 112 109 186L95 480H0Z M298 0H400V480H305L291 186Q270 112 298 0Z" fill="${s}"/>`;
    const yoke=`<path d="M0 0H400V96Q200 77 0 96Z" fill="${s}"/><path d="M0 103Q200 84 400 103" fill="none" stroke="${a}" stroke-width="4"/>`;
    const texture=`<defs><pattern id="${id}-sport-tonal" width="30" height="30" patternUnits="userSpaceOnUse"><path d="M0 15L15 0L30 15L15 30Z" fill="none" stroke="${s}" stroke-opacity=".17" stroke-width="2"/></pattern></defs><rect width="400" height="480" fill="url(#${id}-sport-tonal)"/>`;
    const fade=`<defs><linearGradient id="${id}-sport-fade" x1="0" y1="0" x2="0" y2="${hem}" gradientUnits="userSpaceOnUse"><stop offset=".45" stop-color="${p}"/><stop offset="1" stop-color="${s}"/></linearGradient></defs><rect width="400" height="480" fill="url(#${id}-sport-fade)"/>`;
    const pin=`<defs><pattern id="${id}-sport-pin" width="18" height="18" patternUnits="userSpaceOnUse"><path d="M9 0V18" stroke="${s}" stroke-width="1.5"/></pattern></defs><rect width="400" height="480" fill="url(#${id}-sport-pin)"/>`;
    const diagonal=`<path d="M0 270L400 390V439L0 319Z" fill="${s}"/><path d="M0 327L400 447" stroke="${a}" stroke-width="4"/>`;
    if(bottom)return [rails,bands,rails,bands,texture,fade][n]||'';
    if(profile==='baseball')return [side==='front'?`<path d="M187 66V440 M213 66V440" fill="none" stroke="${a}" stroke-width="3"/>`:'',pin,sleeves,yoke,texture,rails][n];
    if(profile==='basketball')return [bands,rails,pin,`<path d="M80 100H132V245L165 320L132 420H80Z M320 100H268V245L235 320L268 420H320Z" fill="${s}"/>`,texture,fade][n];
    if(profile==='soccer')return [sleeves,`<path d="M115 0H145V480H115Z M185 0H215V480H185Z M255 0H285V480H255Z" fill="${s}"/>`,`<path d="M0 115H400V145H0Z M0 205H400V235H0Z M0 295H400V325H0Z" fill="${s}"/>`,`<path d="M60 40L340 350L309 380L29 70Z" fill="${s}"/>`,texture,fade][n];
    if(profile==='hockey')return [yoke+bands,sleeves+bands,`<path d="M0 239H400V292H0Z" fill="${s}"/>`+bands,bands,texture,`<path d="M0 0H400V90L300 142L240 97H160L100 142L0 90Z" fill="${s}"/>`+bands][n];
    if(profile==='football')return [sleeves,`<path d="M92 66L110 145 M123 66L141 145 M308 66L290 145 M277 66L259 145" stroke="${s}" stroke-width="11"/>`,rails,yoke,texture+ sleeves,fade][n];
    if(profile==='volleyball')return [sleeves,diagonal,yoke,bands,fade,texture][n];
    if(profile==='lacrosse')return [bands,rails,yoke,`<path d="M0 270H400V310H0Z" fill="${s}"/>`,texture,diagonal][n];
    return [sleeves,rails,diagonal,bands,`<path d="M100 300L300 342 M100 312L300 354 M100 324L300 366" stroke="${s}" stroke-width="4"/>`,fade][n];
  }
  function familyGraphics(d,id,side='front') {
    if(d.artworkVersion===2){const art=sportFamilyV2(d,id,side);if(art!==null)return art;}
    if(d.design==='blank') return '';
    const {primary:p,secondary:s,accent:a}=d.colors;
    const bottom=SHORTS.includes(d.product)||PANTS.includes(d.product), shorts=SHORTS.includes(d.product);
    const top=d.product==='quarter'||d.product==='full';
    const y=shorts?145:40, h=shorts?233:410;
    if(d.design==='podium') {
      if(bottom) {
        const band=shorts?276:330;
        return `<path d="M60 ${band}H340V${band+49}H60Z" fill="${s}"/><path d="M60 ${band-8}H340M60 ${band+57}H340" stroke="${a}" stroke-width="4"/><path d="M60 ${y}H340V${y+20}H60Z" fill="${s}"/>`;
      }
      return `<path d="M0 173Q200 191 400 173V235Q200 251 0 235Z" fill="${s}"/><path d="M0 164Q200 182 400 164M0 244Q200 260 400 244" stroke="${a}" stroke-width="4" fill="none"/><path d="M0 0H400V70H0ZM0 382H400V400H0Z" fill="${s}"/>`;
    }
    if(d.design==='contour') {
      // Sleeve panels follow the set-in armhole seams on both zip styles.
      if(top) return `<path d="M0 0H92V91Q107 129 104 185L105 353Q105 386 107 398L98 405 94 450H0Z M400 0H308V91Q293 129 296 185L295 353Q295 386 293 398L302 405 306 450H400Z" fill="${s}"/>`;

      if(bottom) return `<path d="M60 ${y}H128Q173 ${y+h*.4} 136 ${y+h}H55ZM340 ${y}H272Q227 ${y+h*.4} 264 ${y+h}H345Z" fill="${s}"/><path d="M135 ${y}Q180 ${y+h*.4} 143 ${y+h}M265 ${y}Q220 ${y+h*.4} 257 ${y+h}" stroke="${a}" stroke-width="5" fill="none"/>`;
      return `<path d="M0 0H140Q176 135 132 240Q113 305 172 480H0ZM400 0H260Q224 135 268 240Q287 305 228 480H400Z" fill="${s}"/><path d="M148 0Q184 135 140 240Q121 305 180 480M252 0Q216 135 260 240Q279 305 220 480" fill="none" stroke="${a}" stroke-width="5"/>`;
    }
    if(d.design==='terrain') {
      return `<defs><pattern id="${id}-camo" width="100" height="90" patternUnits="userSpaceOnUse"><rect width="100" height="90" fill="${p}"/><path d="M-12 13L17 3 31 14 26 29 44 35 35 52 8 48-5 32ZM67 66L87 53 110 63 109 85 79 97 60 83Z" fill="${s}"/><path d="M49-8L69 5 63 23 85 30 80 44 57 38 40 23ZM5 67L23 61 37 72 33 92 10 94Z" fill="${a}" opacity=".5"/></pattern></defs><rect width="400" height="480" fill="url(#${id}-camo)"/>${bottom?`<path d="M168 0H232V480H168Z" fill="${p}"/>`:`<path d="M139 0H261V480H139Z" fill="${p}"/>`}<path d="M${bottom?162:133} 0V480M${bottom?238:267} 0V480" stroke="${a}" stroke-width="3"/>`;
    }
    if(d.design==='fade') return `<defs><linearGradient id="${id}-fade" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${p}"/><stop offset=".35" stop-color="${p}"/><stop offset="1" stop-color="${s}"/></linearGradient></defs><rect x="0" y="${y}" width="400" height="${h}" fill="url(#${id}-fade)"/><path d="${bottom?'M118 0L148 480M282 0L252 480':'M112 0L139 480M288 0L261 480'}" stroke="${a}" stroke-width="5" fill="none"/>`;
    if(d.design==='heritage') {
      const star=(x,cy,r)=>Array.from({length:10},(_,i)=>{const t=-Math.PI/2+i*Math.PI/5,k=i%2?r*.43:r;return `${(x+Math.cos(t)*k).toFixed(2)},${(cy+Math.sin(t)*k).toFixed(2)}`;}).join(' ');
      const stars=bottom?[ [133,shorts?200:130],[267,shorts?200:130] ]:[ [155,155],[200,164],[245,155] ];
      const bands=shorts?'M60 307H340V330H60ZM60 341H340V350H60Z':bottom?'M100 335H300V362H100ZM100 374H300V385H100Z':'M0 292L400 242V277L0 327ZM0 341L400 291V301L0 351Z';
      return `<path d="${bands}" fill="${s}"/><path d="${shorts?'M65 332H335':bottom?'M110 367H290':'M0 331L400 281'}" stroke="${a}" stroke-width="4"/>${stars.map(([x,cy])=>`<polygon points="${star(x,cy,bottom?13:15)}" fill="${a}"/>`).join('')}`;
    }
    if(d.design==='classic') {
      if(top) return side==='back'
        ? `<path d="M171 70Q200 82 229 70L222 124H178Z" fill="${s}"/>`
        : `<path d="M92 91L147 62L162 25H238L253 62L308 91L280 183H120Z" fill="${s}"/>`;

      const left=shorts?112:top?122:132, right=400-left;
      return `<path d="M0 0H${left}V480H0ZM${right} 0H400V480H${right}Z" fill="${s}"/><path d="M${left+5} 0V480M${right-5} 0V480" stroke="${a}" stroke-width="6"/>`;
    }
    if(d.design==='velocity') {
      if(bottom) return `<path d="M65 ${y}L155 ${y+h}H100L35 ${y}ZM335 ${y}L245 ${y+h}H300L365 ${y}Z" fill="${s}"/><path d="M83 ${y}L171 ${y+h}M317 ${y}L229 ${y+h}" stroke="${a}" stroke-width="5"/>`;
      return `<path d="M30 70L180 470H90L0 240ZM370 70L220 470H310L400 240Z" fill="${s}"/><path d="M40 45L198 470H186L28 45ZM360 45L202 470H214L372 45Z" fill="${a}"/>`;
    }
    if(d.product==='pants') return `<path d="M0 235L200 305L400 235V480H0Z" fill="${s}"/><path d="M0 226L200 296L400 226" stroke="${a}" stroke-width="7" fill="none"/>`;
    if(bottom) {
      const start=shorts?185:95, end=shorts?245:185;
      return `<path d="M0 ${y}H400V${start}L200 ${end}L0 ${start}Z" fill="${s}"/><path d="M0 ${start+9}L200 ${end+9}L400 ${start+9}" stroke="${a}" stroke-width="7" fill="none"/>`;
    }
    return `<path d="M0 0H400V150L200 247L0 150Z" fill="${s}"/><path d="M0 144L200 240L400 144V157L200 253L0 157Z" fill="${a}"/>`;
  }
  const BLOCK_DIGITS = {
    '0':'M10 0H50L60 10V90L50 100H10L0 90V10Z M18 18V82H42V18Z',
    '1':'M12 0H40V82H55V100H5V82H20V23H5V10Z',
    '2':'M10 0H50L60 10V44L18 77V82H60V100H0V68L42 35V18H18V30H0V10Z',
    '3':'M0 0H50L60 10V42L51 50L60 58V90L50 100H0V82H42V60H15V42H42V18H0Z',
    '4':'M0 0H18V42H40V0H58V100H40V60H0Z',
    '5':'M0 0H60V18H18V39H50L60 49V90L50 100H0V82H42V57H0Z',
    '6':'M10 0H60V18H18V40H50L60 50V90L50 100H10L0 90V10Z M18 58V82H42V58Z',
    '7':'M0 0H60V20L30 100H10L40 18H0Z',
    '8':'M10 0H50L60 10V40L50 50L60 60V90L50 100H10L0 90V60L10 50L0 40V10Z M18 18V41H42V18Z M18 59V82H42V59Z',
    '9':'M10 0H50L60 10V90L50 100H0V82H42V60H10L0 50V10Z M18 18V42H42V18Z'
  };
  function renderLettering(v,modern=false) {
    if(!/^\d{1,3}$/.test(v.text)) return `<text x="${v.textX}" y="${v.textY}" text-anchor="middle" font-family="Arial, sans-serif" font-size="${v.textSize}" font-weight="900" letter-spacing="1" ${modern?'paint-order="stroke fill" stroke="#172821" stroke-width=".8" ':''}${modern&&v.text.length*v.textSize*.62>166?'textLength="166" lengthAdjust="spacingAndGlyphs"':''} fill="${v.textColor}">${esc(v.text)}</text>`;
    const scale=v.textSize/100,width=v.text.length*72-12;
    return `<g data-number-style="college-block" role="img" aria-label="Number ${v.text}" transform="translate(${v.textX-width*scale/2} ${v.textY-v.textSize}) scale(${scale})" fill="${v.textColor}" stroke="#172821" stroke-width="2" stroke-linejoin="miter" paint-order="stroke fill"><title>${v.text}</title>${[...v.text].map((digit,i)=>`<path transform="translate(${i*72} 0)" fill-rule="evenodd" d="${BLOCK_DIGITS[digit]}"/>`).join('')}</g>`;
  }
  function garment(d, side, id, labels = true) {
    const { primary:p,secondary:s,accent:a } = d.colors, shape = outline(d.product,side), v = viewLogo(d,side);
    const graphics = familyGraphics(d,id,side);
    const stripes = d.pinstripe?.enabled ? `<defs><pattern id="${id}-pinstripe" width="16" height="16" patternUnits="userSpaceOnUse"><path d="M8 0V16" fill="none" stroke="${color(d.pinstripe.color,'#ffffff')}" stroke-width="1"/></pattern></defs><rect width="400" height="480" fill="url(#${id}-pinstripe)"/>` : '';
    const jersey = JERSEYS.includes(d.product);
    const jerseyTrim = sportTrim(d,side);
    const seams = ['baseball_pants','football_pants'].includes(d.product) ? `<path d="M100 35H300V70H100Z" fill="${d.colors.waistband}"/><path d="M110 374H178V403H110Z M222 374H290V403H222Z" fill="${d.colors.ankle}"/><path d="M200 71V166" stroke="#172821" stroke-opacity=".5"/>${d.product==='baseball_pants'?`<path d="M142 42V71 M180 40V71 M220 40V71 M258 42V71" stroke="${p}" stroke-width="7"/>`:''}` : jersey ? jerseyTrim : d.product === 'quarter' || d.product === 'full' ? `<defs><pattern id="${id}-rib" width="4" height="8" patternUnits="userSpaceOnUse"><path d="M1 0V8" stroke="#172821" stroke-opacity=".25" stroke-width=".8"/></pattern></defs><path d="M162 25Q200 17 238 25Q242 53 253 62Q200 91 147 62Q158 53 162 25Z M107 398Q200 416 293 398L291 430Q200 442 109 430Z M52 402L98 405 94 439 57 439Z M302 405L348 402 343 439 306 439Z" fill="${p}"/><path d="M162 25Q200 17 238 25Q242 53 253 62Q200 91 147 62Q158 53 162 25Z M107 398Q200 416 293 398L291 430Q200 442 109 430Z M52 402L98 405 94 439 57 439Z M302 405L348 402 343 439 306 439Z" fill="url(#${id}-rib)"/><path d="M92 91Q107 129 104 185L105 353Q105 386 107 398M308 91Q293 129 296 185L295 353Q295 386 293 398M107 398Q200 416 293 398M52 402L98 405M302 405L348 402M147 62Q200 91 253 62" fill="none" stroke="#172821" stroke-opacity=".55" stroke-width="1.5"/><path d="M48 327Q64 367 88 387M352 327Q336 367 312 387" fill="none" stroke="#ffffff" stroke-opacity=".18" stroke-width="2"/>${side === 'front' ? `<path d="M162 25Q200 54 238 25" fill="none" stroke="#172821" stroke-width="1.5"/><path d="M200 29V${d.product === 'full' ? 430 : 153}" stroke="#14221e" stroke-width="5"/><path d="M200 29V${d.product === 'full' ? 430 : 153}" stroke="#e8e9e1" stroke-width="1.2"/><rect x="196" y="49" width="8" height="13" rx="2" fill="#e8e9e1"/>` : ''}` : d.product === 'pants' ? `<defs><pattern id="${id}-elastic" width="7" height="12" patternUnits="userSpaceOnUse"><path d="M2 0Q5 6 2 12" stroke="#172821" stroke-opacity=".4" stroke-width="1"/></pattern></defs><path d="M100 35H300V70Q200 82 100 70Z" fill="${d.colors.waistband || p}"/><path d="M115 431Q141 439 165 431V460H115Z M235 431Q259 439 283 431V460H235Z" fill="${d.colors.ankle || p}"/><path d="M100 35H300V70Q200 82 100 70Z M115 431Q141 439 165 431V460H115Z M235 431Q259 439 283 431V460H235Z" fill="url(#${id}-elastic)"/><path d="M116 71Q200 80 284 71M122 430Q142 437 162 430M238 430Q258 437 278 430M200 77V164M107 252L133 265 115 267M293 252L267 265 285 267M173 295L154 307M227 295L246 307" fill="none" stroke="#172821" stroke-opacity=".45" stroke-width="1.3"/>${side==='front'?`<path d="M122 90L119 159M278 90L281 159" stroke="#172821" stroke-opacity=".6" stroke-width="2"/><circle cx="188" cy="59" r="3" fill="${a}"/><circle cx="212" cy="59" r="3" fill="${a}"/><path d="M188 59C181 72 192 102 182 141M212 59C219 72 208 102 218 141" stroke="#172821" stroke-width="4" fill="none"/><path d="M188 59C181 72 192 102 182 141M212 59C219 72 208 102 218 141" stroke="${a}" stroke-width="2" fill="none"/>`:''}` : SHORTS.includes(d.product) ? `<path d="M75 130H325V165H75Z" fill="${d.colors.waistband || p}"/><path d="M90 ${d.product === 'shorts' ? 165 : 63}H310" stroke="#ffffff" stroke-opacity=".25" stroke-width="3"/><path d="M195 ${d.product === 'shorts' ? 166 : 64}v25m10-25v25" stroke="${a}" stroke-width="3"/>` : `<path data-trim="cuff" d="M80 406Q140 430 178 418L178 450H80ZM222 418Q260 430 320 406V450H222Z" fill="${d.colors.cuff || a}"/><path data-trim="neck" d="${side==='front'?'M164 40 C165 100 168 126 185 132 Q200 140 215 132 C232 126 235 100 236 40':'M161 44 Q167 77 200 76 Q233 77 239 44'}" fill="none" stroke="${d.colors.neck || a}" stroke-width="10"/><path data-trim="arm" d="M143 48 C141 95 143 128 128 153 M257 48 C259 95 257 128 272 153" fill="none" stroke="${d.colors.arm || a}" stroke-width="10"/>`;
    return `<defs><clipPath id="${id}"><path d="${shape}"/></clipPath></defs><path d="${shape}" fill="${p}" stroke="#18271f" stroke-width="1.5"/><g clip-path="url(#${id})">${graphics}${stripes}${labels && v.defaultLogo && !v.logo ? `<svg transform="rotate(${v.logoRotation || 0} ${v.logoX} ${v.logoY})" data-stb-logo="true" x="${v.logoX-v.logoSize/2}" y="${v.logoY-v.logoSize/2}" width="${v.logoSize}" height="${v.logoSize}" viewBox="16 10 284 128" preserveAspectRatio="xMidYMid meet"><g fill="${logoInk(d,v)}">${STB_LOGO}</g></svg>` : ''}${labels && v.logo ? `<image transform="rotate(${v.logoRotation || 0} ${v.logoX} ${v.logoY})" href="${v.logo}" x="${v.logoX-v.logoSize/2}" y="${v.logoY-v.logoSize/2}" width="${v.logoSize}" height="${v.logoSize}" preserveAspectRatio="xMidYMid meet"/>` : ''}${labels ? renderLettering(v,d.artworkVersion===2)+(v.number?renderLettering({text:v.number,textX:v.numberX,textY:v.numberY,textSize:v.numberSize,textColor:v.numberColor}):'') : ''}${fabricDetail(d,id,side)}${seams}</g>`;
  }
  function svg(d, side='front', id='garment', labels=true) { return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 480" role="img" aria-label="${PRODUCTS[d.product]} ${side} concept">${garment(d,side,id,labels)}</svg>`; }
  function sheet(d) {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="850" viewBox="0 0 1200 850"><rect width="1200" height="850" fill="#f4f5ee"/><text x="60" y="65" font-family="Arial" font-weight="bold" font-size="27" fill="#172821">TEAM DESIGN CONCEPT</text><text x="60" y="101" font-family="Arial" font-size="17" fill="#52614b">${PRODUCTS[d.product]} / ${familyName(d)}</text><g transform="translate(140 150) scale(1.1)">${garment(d,'front','export-front')}</g><g transform="translate(620 150) scale(1.1)">${garment(d,'back','export-back')}</g><text x="360" y="730" text-anchor="middle" font-family="Arial" font-size="16">FRONT</text><text x="840" y="730" text-anchor="middle" font-family="Arial" font-size="16">BACK</text><text x="60" y="805" font-family="Arial" font-size="14" fill="#52614b">Concept only. Final artwork, garment construction and colors require approval.</text></svg>`;
  }
  // Pure, PII-safe design snapshot for the quote request. Emits presence + placement only —
  // never the uploaded logo bytes — so artwork can never reach HubSpot or logs through this path.
  function snapshot(d) {
    let keys = ['primary','secondary','accent'];
    if (JERSEYS.includes(d.product)) keys = keys.concat(['neck','arm']);
    else if (d.product === 'singlet') keys = keys.concat(['neck','arm','cuff']);
    else if (PANTS.includes(d.product)) keys = keys.concat(['waistband','ankle']);
    else if (SHORTS.includes(d.product)) keys = keys.concat(['waistband']);
    const colors = {};
    keys.forEach(k => { if (d.colors[k]) colors[k] = d.colors[k]; });
    const side = v => ({ ...(v.number!==undefined?{number:v.number,number_x:v.numberX,number_y:v.numberY,number_size:v.numberSize,number_color:v.numberColor}:{}), text: v.text || '', text_color: v.textColor || '', text_x: v.textX, text_y: v.textY, text_size: v.textSize, has_logo: Boolean(v.logo || v.defaultLogo), logo_color: logoInk(d,v), logo_rotation: v.logoRotation || 0, logo_x: v.logoX, logo_y: v.logoY, logo_size: v.logoSize });
    return {
      ...(d.artworkVersion?{artwork_version:d.artworkVersion,sport_profile:d.sportProfile}:{}),
      garment: PRODUCTS[d.product] || d.product, garment_id: d.product,
      design_family: familyName(d) || d.design, design_family_id: d.design,
      colors,
      pinstripe_enabled: Boolean(d.pinstripe && d.pinstripe.enabled), pinstripe_color: (d.pinstripe && d.pinstripe.color) || '',
      front: side(viewLogo(d,'front')), back: side(viewLogo(d,'back')),
      has_logo: Boolean(d.views.front.logo || d.views.front.defaultLogo || d.views.back.logo || d.views.back.defaultLogo),
      refinement_notes: ((d.wrapSource?'Logo wraps from '+d.wrapSource+' across the side seam (concept placement). ':'')+(d.notes||'')).slice(0,1200)
    };
  }
  function validQuantity(value) {return String(value).trim()!=='' && Number.isInteger(Number(value)) && Number(value)>=1 && Number(value)<=10000;}
  function readProject(raw) {
    if(raw.kind!=='smartkits-kit')return {current:normalize(raw),items:[]};
    if(raw.version!==2 || !Array.isArray(raw.items) || raw.items.length>12)throw new Error('Invalid kit project.');
    return {revision:typeof raw.revision==='string'?raw.revision:null,draftQuantity:raw.draftQuantity??(Number.isInteger(raw.activeIndex)?raw.items[raw.activeIndex]?.quantity:undefined)??1,draftTouched:raw.draftTouched!==false,activeItem:Number.isInteger(raw.activeIndex)&&raw.activeIndex>=0&&raw.activeIndex<raw.items.length?String(raw.activeIndex):null,current:normalize(raw.current),items:raw.items.map((i,n)=>({id:String(n),name:String(i.name||'Garment').slice(0,80),quantity:typeof i.quantity==='number'||typeof i.quantity==='string'?i.quantity:1,selected:i.selected!==false,design:normalize(i.design)}))};
  }
  const core = { familyName, seedNumbers, numberDefaults, SPORTS, sportKey, outline, validQuantity, readProject, defaults, normalize, svg, sheet, snapshot, viewLogo, seamBounds, PRODUCTS, DESIGNS, DESIGN_NAMES, familyGraphics, logoPlacement, LOGO_LAYOUTS };
  if (typeof document === 'undefined') { module.exports = core; return; }
  if (typeof window !== 'undefined') window.STBSmartKitsCore = core;
  if (customElements.get('stb-design-studio')) return;
  let sequence = 0;
  class Studio extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const selectedSport = this.dataset.pageSport || this.dataset.sport;
      this.sport = Object.hasOwn(SPORTS,selectedSport) ? selectedSport : 'wrestling';
      this.storageKey = sportKey(this.sport);
      this.allowedProducts = (this.sport !== 'wrestling' ? SPORTS[this.sport].join(',') : (this.dataset.products || SPORTS.wrestling.join(',')))
        .split(',')
        .map((k) => k.trim())
        .filter((k) => Object.hasOwn(PRODUCTS, k));
      if (!this.allowedProducts.length) this.allowedProducts = SPORTS[this.sport];
      this.ready = true;
      this.uid = 'stb-' + ++sequence;
      this.d = defaults();
      this.d.product = this.allowedProducts[0];
      this.d.artworkVersion=2;this.d.sportProfile=this.sport;
      seedNumbers(this.d);
      if(this.sport !== 'wrestling') this.d.views.front.defaultLogo = false;
      const splash=document.querySelector('.sk-splash');
      if(splash){
        const eyebrow=splash.querySelector('.sk-splash__eyebrow'); if(eyebrow) eyebrow.textContent='SmartKits · Custom '+this.sport.replace('-',' ')+' apparel';
        splash.querySelectorAll('[data-kit-sport]').forEach(link=>{if(link.dataset.kitSport===this.sport)link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');});
        const gear=splash.querySelector('.sk-splash__gear');
        if(gear&&this.sport!=='wrestling') gear.innerHTML=SPORTS[this.sport].filter(key=>key!=='full').slice(0,3).map((product,n)=>`<figure class="sk-splash__garment">${svg({...this.d,product},'front',this.uid+'-hero-'+n,false)}<figcaption>${PRODUCTS[product]}</figcaption></figure>`).join('');
      }
      this.side = 'front';
      this.step = 0;
      this.undoStack = [];
      this.items = [];
      this.activeItem = null;
      this.draftQuantity = 1;
      this.revision = null;
      this.loading = true;
      this.kitHistory = [];
      this.draftTouched = false;
      this.innerHTML = `<div class="shell"><header class="mast"><div class="brand"><i>///</i> ${esc(this.dataset.brand || 'STB')} <span class="eyebrow">SmartKits</span></div><div class="header-actions"><span data-save-status role="status" tabindex="-1">Loading draft…</span><button class="quiet" data-action="download">Download backup</button><button class="quiet" data-action="import">Open project</button><button class="quiet" data-action="save">Save draft</button></div></header><section class="intro"><div><div class="eyebrow">Team apparel designer</div><h1>SmartKits</h1><p>Create your coordinated team look.</p></div><span class="pill">● ${esc(this.sport[0].toUpperCase()+this.sport.slice(1))} team kits</span></section><div class="workspace"><section class="stage" aria-label="Garment preview"><div class="stage-top"><div><strong data-title></strong><small data-subtitle></small></div><div class="views"><button data-side="front">Front</button><button data-side="back">Back</button></div></div><div class="canvas"></div><div class="stage-foot"><span>Original concept • Front & back preview</span><div class="palette-dots" aria-label="Selected colors"></div></div></section><section class="panel" aria-label="Design controls"><p data-current-state role="status"></p><label>Garment quantity <input type="number" min="1" max="10000" step="1" value="1" required data-draft-quantity></label><button class="primary" data-action="add-kit">Add to kit</button><button class="secondary" data-action="compare">Compare another look</button><p class="help">Choose a step below, or use the Next buttons to continue.</p><nav class="steps" aria-label="Design steps">${['Style', 'Colors', 'Personalize', 'Review'].map((s, i) => `<button data-step="${i}"><span>${i + 1}</span>${s}</button>`).join('')}</nav><div data-controls></div><div class="status" role="status" aria-live="polite"></div></section></div><section class="kit-tray" aria-label="Your team kit"><h2 data-kit-heading tabindex="-1">Your kit &amp; comparisons</h2><p>Check the garments to include. Use Compare another look to preserve your original.</p><p data-kit-summary></p><button type="button" class="quiet" data-action="toggle-alternatives">Hide / show alternatives</button><button type="button" class="quiet" data-action="undo-kit">Undo kit removal / import</button><div data-conflict hidden><p>Another tab changed this project. Download your copy before loading its newer version.</p><button type="button" class="secondary" data-action="resolve-conflict">Download my copy and load latest</button></div><div data-kit></div><div data-quote-review></div></section><footer class="footer"><span>Designed by you. Refined together.</span><span>Concept previews; final fit and artwork confirmed before production.</span></footer><input class="hidden" data-import type="file" accept="application/json,.json" aria-label="Open editable design file"></div>`;
      this.addEventListener('pointerdown', (e) => {
        const button = e.target.closest('[data-side]');
        if (button) {
          e.preventDefault();
          button.focus({ preventScroll: true });
        }
      });
      this.addEventListener('click', (e) => this.click(e));
      this.addEventListener('input', (e) => this.input(e));
      this.addEventListener('change', (e) => this.change(e));
      const canvas = this.$('.canvas');
      canvas.addEventListener('pointerdown', (e) => {
        if (
          this.step !== 2 ||
          !(this.d.views[this.side].logo || this.d.views[this.side].defaultLogo) ||
          e.button !== 0
        )
          return;
        const matrix = canvas.querySelector('svg').getScreenCTM();
        if (!matrix) return;
        this.checkpoint();
        this.drag = { id: e.pointerId, inverse: matrix.inverse() };
        canvas.setPointerCapture(e.pointerId);
        this.placeLogo(e);
      });
      canvas.addEventListener('pointermove', (e) => {
        if (this.drag?.id === e.pointerId) this.placeLogo(e);
      });
      const endDrag = (e) => {
        if (this.drag?.id === e.pointerId) {
          this.drag = null;
          this.message(
            'Logo placement updated. Artwork crossing the side continues on the opposite view.',
          );
        }
      };
      canvas.addEventListener('pointerup', endDrag);
      canvas.addEventListener('pointercancel', endDrag);
      canvas.addEventListener('lostpointercapture', endDrag);
      try {
        const raw = localStorage.getItem(this.storageKey) || (this.sport==='wrestling' && localStorage.getItem('stb-design-v1'));
        if (raw) {
          const project = readProject(JSON.parse(raw));
          if (!this.allowedProducts.includes(project.current.product) || project.items.some((i) => !this.allowedProducts.includes(i.design.product)))
            throw new Error();
          this.loadProject(project);
          this.revision = project.revision || null;
        }
      } catch {
        this.message('Saved project could not be opened. Your stored copy has not been overwritten.');
        this.conflict = true;
      }
      const header = document.querySelector('.site-header');
      if (header) {
        this.headerObserver = new ResizeObserver(() =>
          this.style.setProperty('--smartkits-header', header.getBoundingClientRect().height + 'px'),
        );
        this.headerObserver.observe(header);
        this.style.setProperty('--smartkits-header', header.getBoundingClientRect().height + 'px');
      }
      this.loading = false;
      this.lastSaved = JSON.stringify({ ...this.project(), revision: null });
      this.render();
      this.$('[data-draft-quantity]').value = this.draftQuantity;
      this.storageListener = (e) => {
        if (e.key === this.storageKey) {
          this.conflict = true;
          clearTimeout(this.saveTimer);
          this.showConflict();
        }
      };
      window.addEventListener('storage', this.storageListener);
      this.sportNavigation = async (event) => {
        const link=event.target.closest('[data-kit-sport]');
        if(!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        clearTimeout(this.saveTimer);
        await this.persist();
        if(this.conflict || this.lastSaved !== JSON.stringify({...this.project(),revision:null})){
          this.message('Your draft could not be saved. Download a backup or resolve the save issue before switching sports.');
          this.$('[data-save-status]').focus();
          return;
        }
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('sport', link.dataset.kitSport);
        nextUrl.hash = '';
        window.location.assign(nextUrl.href);
      };
      document.addEventListener('click',this.sportNavigation);
    }
    disconnectedCallback() {
      clearTimeout(this.saveTimer);
      clearTimeout(this.kitTimer);
      window.removeEventListener('storage', this.storageListener);
      document.removeEventListener('click',this.sportNavigation);
      this.headerObserver?.disconnect();
    }
    $(s) {
      return this.querySelector(s);
    }
    message(s) {
      this.$('.status').textContent = s;
    }
    checkpoint() {
      this.draftTouched = true;
      this.undoStack.push(JSON.stringify(this.d));
      if (this.undoStack.length > 30) this.undoStack.shift();
    }
    placeLogo(e) {
      const point = new DOMPoint(e.clientX, e.clientY).matrixTransform(this.drag.inverse);
      const v = this.editLogo();
      if (v.defaultLogo && v.logoAuto)
        Object.assign(v, designLogoPlacement(this.d,this.side));
      v.logoAuto = false;
      v.logoX = Math.round(clamp(point.x, -400, 800, 200));
      v.logoY = Math.round(clamp(point.y, -480, 960, 240));
      for (const key of ['logoX', 'logoY']) {
        const input = this.$('[data-field="' + key + '"]');
        if (input) input.value = v[key];
      }
      this.d.wrapSource = this.side;
      this.preview();
    }
    editLogo() {
      const resolved = viewLogo(this.d, this.side);
      Object.assign(this.d.views[this.side], resolved, { logoAuto: false });
      return this.d.views[this.side];
    }
    isDirty() {
      const saved = this.items.find((i) => i.id === this.activeItem);
      return saved
        ? JSON.stringify(normalize(saved.design)) !== JSON.stringify(normalize(this.d)) ||
            String(saved.quantity) !== String(this.draftQuantity)
        : Boolean(this.draftTouched);
    }
    project() {
      return {
        version: 2,
        kind: 'smartkits-kit',
        revision: this.revision,
        current: this.d,
        activeIndex: this.items.findIndex((i) => i.id === this.activeItem),
        items: this.items,
        draftQuantity: this.draftQuantity,
        draftTouched: this.draftTouched,
      };
    }
    async choose(title, choices) {
      const dialog = document.createElement('dialog');
      dialog.className = 'kit-dialog';
      dialog.innerHTML = `<h2>${esc(title)}</h2>${choices.map(([value, label]) => `<button type="button" class="secondary" data-choice="${value}">${esc(label)}</button>`).join('')}`;
      this.append(dialog);
      dialog.setAttribute('aria-label', title);
      return new Promise((resolve) => {
        const done = (value) => {
          dialog.close();
          dialog.remove();
          resolve(value);
        };
        dialog.addEventListener('cancel', (e) => {
          e.preventDefault();
          done('cancel');
        });
        dialog.addEventListener('click', (e) => {
          const button = e.target.closest('[data-choice]');
          if (button) {
            e.stopPropagation();
            done(button.dataset.choice);
          }
        });
        dialog.showModal();
      });
    }
    async resolveDraft() {
      if (!this.isDirty()) return true;
      const answer = await this.choose('Keep this garment before continuing?', [
        ['save', this.activeItem ? 'Update kit item' : 'Add to kit'],
        ['discard', 'Discard these edits'],
        ['cancel', 'Keep editing'],
      ]);
      if (answer === 'cancel') return false;
      if (answer === 'save') return this.saveItem();
      return true;
    }
    saveItem() {
      if (!validQuantity(this.draftQuantity)) {
        this.message('Enter a whole-number quantity from 1 to 10,000.');
        this.$('[data-draft-quantity]').focus();
        return false;
      }
      let item = this.items.find((i) => i.id === this.activeItem);
      if (!item) {
        if (this.items.length >= 12) {
          this.message('Your kit already has 12 items. Remove an item before adding another.');
          return false;
        }
        item = {
          id: crypto.randomUUID(),
          name:
            PRODUCTS[this.d.product] +
            ' / ' +
            familyName(this.d) +
            ' ' +
            (this.items.length + 1),
          selected: !this.isAlternative,
        };
        this.items.push(item);
        this.activeItem = item.id;
      }
      this.d = normalize(this.d);
      item.design = normalize(this.d);
      item.quantity = Number(this.draftQuantity);
      this.isAlternative = false;
      this.render();
      this.message('Kit item updated. Review the checked items before quoting.');
      return true;
    }
    focusQuoteIssue() {
      const draft = !this.activeItem || this.isDirty();
      const target = draft
        ? this.$('[data-action="add-kit"]')
        : this.$('[data-kit] input[aria-invalid="true"]') ||
          this.$('[data-kit] input[type="checkbox"]');
      if (target) {
        target.scrollIntoView({ block: 'center' });
        target.focus({ preventScroll: true });
      }
    }
    getQuoteItems() {
      if (this.conflict)
        throw new Error(
          'Resolve the other tab’s changes or download your project backup before quoting.',
        );
      if (!this.activeItem || this.isDirty())
        throw new Error(
          this.activeItem
            ? 'Update your edited kit item before requesting a quote.'
            : 'Add the garment you are editing to your kit before requesting a quote.',
        );
      const selected = this.items.filter((i) => i.selected);
      if (!selected.length) throw new Error('Select at least one kit item to request a quote.');
      if (selected.some((i) => !validQuantity(i.quantity)))
        throw new Error('Each selected garment needs a whole-number quantity from 1 to 10,000.');
      return selected.map((i) => ({
        ...i,
        quantity: Number(i.quantity),
        design: normalize(i.design),
      }));
    }
    scheduleSave() {
      if (this.loading) return;
      clearTimeout(this.saveTimer);
      this.$('[data-save-status]').textContent = this.conflict
        ? 'Another tab changed this project — resolve below.'
        : 'Saving…';
      this.saveTimer = setTimeout(() => this.persist(), 500);
    }
    async persist() {
      if (this.conflict) return;
      if (JSON.stringify({ ...this.project(), revision: null }) === this.lastSaved) {
        this.$('[data-save-status]').textContent = 'Saved in this browser';
        return;
      }
      try {
        if (!navigator.locks)
          throw new Error('Browser autosave unavailable. Download a project backup.');
        await navigator.locks.request(this.storageKey, () => {
          const raw = localStorage.getItem(this.storageKey),
            latest = raw ? JSON.parse(raw) : null;
          if ((latest?.revision || null) !== (this.revision || null)) {
            this.conflict = true;
            this.showConflict();
            return;
          }
          const revision = crypto.randomUUID();
          localStorage.setItem(this.storageKey, JSON.stringify({ ...this.project(), revision }));
          this.revision = revision;
          this.lastSaved = JSON.stringify({ ...this.project(), revision: null });
          this.$('[data-save-status]').textContent = 'Saved in this browser';
        });
      } catch (err) {
        this.$('[data-save-status]').textContent = 'Save failed — download a project backup.';
      }
    }
    showConflict() {
      this.$('[data-conflict]').hidden = false;
      this.$('[data-save-status]').textContent =
        'Another tab changed this project. Your edits are preserved here.';
    }
    loadProject(project) {
      this.items = project.items;
      this.activeItem = project.activeItem;
      this.d = project.current;
      this.draftTouched = project.draftTouched !== false;
      this.draftQuantity =
        project.draftQuantity ?? this.items.find((i) => i.id === this.activeItem)?.quantity ?? 1;
      this.undoStack = [];
    }
    updateKitSummary() {
      const chosen = this.items.filter((i) => i.selected),
        valid = chosen.every((i) => validQuantity(i.quantity));
      this.$('[data-kit-summary]').textContent =
        `${chosen.length} selected garment${chosen.length === 1 ? '' : 's'} • ${valid ? chosen.reduce((n, i) => n + Number(i.quantity), 0) : 'Check quantities'} total units`;
      this.$('[data-quote-review]').innerHTML = chosen.length
        ? `<h3>Included in your quote</h3><ul>${chosen.map((i) => `<li>${esc(i.name)} — ${PRODUCTS[i.design.product]}, ${familyName(i.design)} — quantity ${esc(i.quantity)}</li>`).join('')}</ul>`
        : '<p>No garments selected for a quote.</p>';
      this.dispatchEvent(new CustomEvent('smartkits:review', { bubbles: true }));
    }
    renderKit() {
      this.updateKitSummary();
      this.$('[data-current-state]').textContent =
        (this.activeItem ? this.items.find((i) => i.id === this.activeItem)?.name : 'New garment') +
        ' — ' +
        (!this.activeItem || this.isDirty() ? 'not updated in kit' : 'saved to kit');
      const save = this.$('[data-action="add-kit"]');
      save.textContent = this.activeItem ? 'Update kit item' : 'Add to kit';
      this.$('[data-kit]').innerHTML = this.items
        .map(
          (i, n) =>
            `<article class="kit-card" ${this.hideAlternatives && !i.selected ? 'hidden' : ''}><label><input type="checkbox" data-kit-select="${i.id}" ${i.selected ? 'checked' : ''}> Include ${esc(i.name)} in quote</label><input aria-label="Item ${n + 1} name" maxlength="80" data-kit-name="${i.id}" value="${esc(i.name)}"><div class="kit-views">${svg(i.design, 'front', this.uid + '-kit-' + n + '-f')}${svg(i.design, 'back', this.uid + '-kit-' + n + '-b')}</div><label>Quantity <input type="number" min="1" max="10000" step="1" required aria-invalid="${!validQuantity(i.quantity)}" data-kit-quantity="${i.id}" value="${esc(i.quantity)}"></label><small data-quantity-error>${validQuantity(i.quantity) ? '' : 'Use a whole number from 1 to 10,000.'}</small><button type="button" class="quiet" data-kit-edit="${i.id}">${i.id === this.activeItem ? 'Editing' : 'Edit'}</button> <button type="button" class="quiet" data-kit-remove="${i.id}">Remove</button></article>`,
        )
        .join('');
    }
    snapshotDesign(design) {
      return snapshot(design);
    }
    getDesignSnapshot() {
      return snapshot(this.d);
    }
    async getQuotePreviews(items) {
      return Promise.all(
        items.map(async (item) => ({ name: item.name, blob: await this.pngBlob(item.design) })),
      );
    }
    async pngBlob(design) {
      const img = new Image();
      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('Image export timed out.')), 15000);
        img.onload = () => {
          clearTimeout(timeout);
          resolve();
        };
        img.onerror = () => {
          clearTimeout(timeout);
          reject(new Error('Could not render this design.'));
        };
        img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(sheet(design));
      });
      const canvas = document.createElement('canvas');
      canvas.width = 1200;
      canvas.height = 850;
      canvas.getContext('2d').drawImage(img, 0, 0, 1200, 850);
      const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
      if (!blob) throw new Error('Could not create the image.');
      return blob;
    }
    preview() {
      this.dispatchEvent(
        new CustomEvent('smartkits:change', {
          bubbles: true,
          detail: {
            product: PRODUCTS[this.d.product],
            family: familyName(this.d),
            colors: this.d.colors,
            frontText: this.d.views.front.text,
            backText: this.d.views.back.text,
            notes: this.d.notes,
            hasLogo: Boolean(
              this.d.views.front.logo ||
              this.d.views.back.logo ||
              this.d.views.front.defaultLogo ||
              this.d.views.back.defaultLogo,
            ),
          },
        }),
      );
      this.scheduleSave();
      clearTimeout(this.kitTimer);
      this.kitTimer = setTimeout(() => this.renderKit(), 150);
      this.$('.canvas').classList.toggle(
        'placing-logo',
        this.step === 2 &&
          Boolean(this.d.views[this.side].logo || this.d.views[this.side].defaultLogo),
      );
      this.$('.canvas').innerHTML = svg(this.d, this.side, this.uid + '-main');
      this.$('[data-title]').textContent = PRODUCTS[this.d.product];
      this.$('[data-subtitle]').textContent =
        familyName(this.d) + ' / ' + (this.side === 'front' ? 'Front' : 'Back');
      this.querySelectorAll('[data-side]').forEach((b) =>
        b.setAttribute('aria-pressed', String(b.dataset.side === this.side)),
      );
      this.$('.palette-dots').innerHTML = Object.values(this.d.colors)
        .map((c) => `<i style="background:${c}"></i>`)
        .join('');
    }
    range(label, key, min, max, value) {
      return `<label for="${this.uid}-${key}">${label}</label><input id="${this.uid}-${key}" type="range" data-field="${key}" min="${min}" max="${max}" value="${value}"><input aria-label="${label} value" type="number" data-field="${key}" min="${min}" max="${max}" value="${value}">`;
    }
    render() {
      const scrollX = window.scrollX,
        scrollY = window.scrollY;
      const controls = this.$('[data-controls]');
      controls.style.minHeight =
        this.renderedStep === this.step ? controls.offsetHeight + 'px' : '0px';
      this.renderedStep = this.step;
      this.preview();
      this.renderKit();
      this.$('[data-draft-quantity]').value = this.draftQuantity;
      this.querySelectorAll('[data-step]').forEach((b) =>
        b.setAttribute('aria-current', Number(b.dataset.step) === this.step ? 'step' : 'false'),
      );
      const d = this.d,
        v = viewLogo(d, this.side);
      let html = '';
      if (this.step === 0)
        html = `<h2>Find your starting point.</h2><p class="help">Choose a family or start with a blank garment.</p><h3>01 / Choose your gear</h3><div class="products">${this.allowedProducts.map(key=>[key,PRODUCTS[key]])
          .map(
            ([key, label]) =>
              `<button class="product" data-product="${key}" aria-pressed="${d.product === key}">${svg({ ...d, product: key }, 'front', this.uid + '-p-' + key, false)}${label}</button>`,
          )
          .join('')}</div><h3>02 / Choose a family</h3><div class="designs">${Object.entries(DESIGNS)
          .map(
            ([key, label]) =>
              `<button class="design" data-design="${key}" aria-pressed="${d.design === key}">${svg({ ...d, design: key }, 'front', this.uid + '-d-' + key, false)}${familyName({...d,design:key})}</button>`,
          )
          .join(
            '',
          )}</div><button class="secondary" data-design="blank" aria-pressed="${d.design === 'blank'}">Blank / Freeform</button><p class="help">${d.artworkVersion===2&&d.sportProfile!=='wrestling'?'Original '+familyName(d)+' layout. Names, numbers and logos remain editable.':FAMILY_NOTES[d.design]} Switch gear above to see the matching layout.</p><button class="primary" data-step="1">Next: Choose colors →</button>`;
      if (this.step === 1)
        html = `<h2>Wear your colors.</h2><p class="help">A few changes. A completely different team.</p>${Object.entries(
          d.colors,
        )
          .filter(
            ([key]) =>
              ['primary', 'secondary', 'accent'].includes(key) ||
              (d.product === 'singlet' && ['neck', 'arm', 'cuff'].includes(key)) ||
              (JERSEYS.includes(d.product) && ['neck','arm'].includes(key)) ||
              (PANTS.includes(d.product) && ['waistband', 'ankle'].includes(key)) ||
              (SHORTS.includes(d.product) && key === 'waistband'),
          )
          .map(
            ([key, c]) =>
              `<div class="color-row"><label for="${this.uid}-${key}">${{ neck: 'Neck binding', arm: sleeveless(d.product)?'Armhole binding':'Sleeve trim', cuff: 'Leg cuffs', waistband: 'Waistband', ankle: 'Ankle cuffs' }[key] || key[0].toUpperCase() + key.slice(1)}</label><input id="${this.uid}-${key}" type="color" data-color="${key}" value="${c}"></div>`,
          )
          .join(
            '',
          )}<h3>Pinstripes</h3><label class="stripe-toggle"><input type="checkbox" data-pinstripe-toggle ${d.pinstripe?.enabled ? 'checked' : ''}> Add fine vertical pinstripes</label>${d.pinstripe?.enabled ? `<div class="color-row"><label for="${this.uid}-stripe-color">Pinstripe color</label><input id="${this.uid}-stripe-color" type="color" data-pinstripe-color value="${d.pinstripe.color}"></div>` : ''}<h3>Try a team palette</h3><div class="swatches">${[
          ['STB', '#111111', '#b8f36d', '#ffffff'],
          ['Royal', '#18367b', '#f4f5ee', '#efba45'],
          ['Crimson', '#821d35', '#f4f5ee', '#162226'],
          ['Midnight', '#17212c', '#92bfe2', '#f4f5ee'],
          ['Flame', '#202a27', '#ff733d', '#f4f5ee'],
        ]
          .map(
            ([name, p, s, a]) =>
              `<button class="swatch" aria-label="${name} palette" title="${name}" style="--swatch:${p}" data-palette="${p},${s},${a}"></button>`,
          )
          .join(
            '',
          )}</div><button class="primary" data-step="2">Next: Add logo & lettering →</button>`;
      if (this.step === 2)
        html = `<h2>Put your name on it.</h2><p class="help">Editing the <strong>${this.side}</strong>. Switch the preview to personalize the other side.</p><label for="${this.uid}-text">${JERSEYS.includes(d.product)?(this.side==='front'?'Team name':'Player name'):'Lettering'}</label><input id="${this.uid}-text" data-field="text" type="text" maxlength="24" value="${esc(v.text)}" placeholder="Team name or number"><div class="color-row"><label for="${this.uid}-textColor">Lettering color</label><input id="${this.uid}-textColor" data-field="textColor" type="color" value="${v.textColor}"></div><details><summary>Adjust lettering placement</summary>${this.range('Left / right', 'textX', 95, 305, v.textX)}${this.range('Up / down', 'textY', 90, 420, v.textY)}${this.range('Text size', 'textSize', 12, 110, v.textSize)}</details>${JERSEYS.includes(d.product)?`<h3>Jersey number</h3><label for="${this.uid}-number">Number</label><input id="${this.uid}-number" data-field="number" type="text" inputmode="numeric" pattern="[0-9]{0,3}" maxlength="3" value="${esc(v.number||'')}" placeholder="12"><label for="${this.uid}-numberColor">Number color</label><input id="${this.uid}-numberColor" data-field="numberColor" type="color" value="${v.numberColor||v.textColor}"><details><summary>Adjust number placement</summary>${this.range('Number left / right','numberX',95,305,v.numberX??200)}${this.range('Number up / down','numberY',90,420,v.numberY??218)}${this.range('Number size','numberSize',30,110,v.numberSize??84)}</details>`:''}<h3>Team logo</h3>${this.sport==='wrestling'?'<button class="secondary" data-action="stb-logo">Use STB logo</button>':''}<div class="upload"><label for="${this.uid}-logo">Upload a PNG or JPEG</label><input id="${this.uid}-logo" data-logo type="file" accept="image/png,image/jpeg"><p class="help">Transparent PNG works best. Up to 5 MB.</p></div>${v.logo || v.defaultLogo ? `${v.defaultLogo ? `<div class="color-row"><label for="${this.uid}-logoColor">Logo color</label><input id="${this.uid}-logoColor" data-field="logoColor" type="color" value="${logoInk(d, v)}"></div>` : ''}<details open><summary>Adjust logo placement</summary><p class="help">Click or drag on the preview to place your logo. Enlarge it and move it past an edge for a cropped mascot. Use the sliders for fine adjustments.</p>${this.range('Logo left / right', 'logoX', -400, 800, v.logoX)}${this.range('Logo up / down', 'logoY', -480, 960, v.logoY)}${this.range('Logo size', 'logoSize', 25, 800, v.logoSize)}${this.range('Logo rotation (degrees)', 'logoRotation', -180, 180, v.logoRotation || 0)}<button type="button" class="secondary" data-action="rotate-logo">Rotate logo 90° ↻</button>${d.wrapSource ? '<button type="button" class="secondary" data-action="unlink-logo">Use independent front/back logos</button>' : ''}<p class="help">Moving a logo across a side edge continues it onto the opposite view. Front/back wrapping is a concept; your designer aligns the final seams.</p><div class="two"><button class="secondary" data-action="crop-left">Crop at left edge</button><button class="secondary" data-action="crop-right">Crop at right edge</button></div><button class="secondary" data-action="reset-logo">Reset logo placement</button><button class="secondary" data-action="remove-logo">Remove logo</button></details>` : ''}<button class="primary" data-step="3">Next: Review & request quote →</button>`;
      if (this.step === 3)
        html = `<h2>Your vision, captured.</h2><p class="help">Add or update this garment in your kit, then review your selected items and request one quote for the whole kit.</p><div class="review"><dl><dt>Garment</dt><dd>${PRODUCTS[d.product]}</dd><dt>Style</dt><dd>${familyName(d)}</dd><dt>Front text</dt><dd>${esc(d.views.front.text) || '—'}</dd><dt>Back text</dt><dd>${esc(d.views.back.text) || '—'}</dd>${JERSEYS.includes(d.product)?`<dt>Front number</dt><dd>${esc(d.views.front.number||'')||'—'}</dd><dt>Back number</dt><dd>${esc(d.views.back.number||'')||'—'}</dd>`:''}</dl></div><label for="${this.uid}-notes">What would you like us to refine?</label><textarea id="${this.uid}-notes" data-notes maxlength="1200" placeholder="Placement, special artwork, team details…">${esc(d.notes)}</textarea><button class="primary" data-action="review-kit">Review selected kit →</button><p class="help">Check quantities below before completing the quote form. Downloads are optional; your design previews are included with your request.</p><button class="secondary" data-action="download">Save SmartKits project (JSON) ↓</button><button class="secondary" data-action="svg">Download editable artwork (SVG) ↓</button><button class="secondary" data-action="png">Download front/back image ↓</button><p class="note">SVG opens in vector design software; uploaded logos remain images. The project file reopens your whole kit here. These are concepts, not production patterns.</p><button class="secondary" data-action="undo">Undo last edit</button>`;
      this.$('[data-controls]').innerHTML =
        html +
        (this.step > 0
          ? `<button type="button" class="secondary" data-step="${this.step - 1}">← Back to ${['styles', 'colors', 'personalization'][this.step - 1]}</button>`
          : '');
      this.querySelectorAll('button').forEach((button) => (button.type = 'button'));
      window.scrollTo({ left: scrollX, top: scrollY, behavior: 'instant' });
    }
    async click(e) {
      const b = e.target.closest('button');
      if (!b || !this.contains(b)) return;
      e.preventDefault();
      if (b.dataset.step !== undefined) {
        this.step = Number(b.dataset.step);
        this.render();
        this.$('.panel').scrollIntoView({ block: 'start', behavior: 'smooth' });
        return;
      }
      if (b.dataset.side) {
        const x = window.scrollX,
          y = window.scrollY;
        this.side = b.dataset.side;
        if (this.step === 2) this.render();
        else this.preview();
        requestAnimationFrame(() => window.scrollTo({ left: x, top: y, behavior: 'instant' }));
        return;
      }
      if (b.dataset.product && this.allowedProducts.includes(b.dataset.product)) {
        if (b.dataset.product === this.d.product) return;
        if (!(await this.resolveDraft())) return;
        this.activeItem = null;
        const previousProduct=this.d.product;
        this.d.product = b.dataset.product;
        this.d.artworkVersion=2;this.d.sportProfile=this.sport;
        seedNumbers(this.d,previousProduct);
        this.draftTouched = false;
        this.undoStack = [];
        this.render();
        return;
      }
      if (b.dataset.design) {
        if (this.activeItem && b.dataset.design !== this.d.design) {
          const choice = await this.choose('Try another family?', [
            ['compare', 'Create an alternative'],
            ['edit', 'Edit this kit item'],
            ['cancel', 'Keep current family'],
          ]);
          if (choice === 'cancel') return;
          if (choice === 'compare') {
            if (!(await this.resolveDraft())) return;
            this.activeItem = null;
            this.isAlternative = true;
            this.undoStack = [];
          }
        }
        this.checkpoint();
        const upgradeArtwork=this.d.artworkVersion!==2;
        this.d.design = b.dataset.design;
        this.d.artworkVersion=2;this.d.sportProfile=this.sport;
        if(upgradeArtwork)seedNumbers(this.d);
        this.render();
        return;
      }
      if (b.dataset.palette) {
        this.checkpoint();
        const [primary, secondary, accent] = b.dataset.palette.split(',');
        this.d.colors = { ...this.d.colors, primary, secondary, accent };
        this.render();
        return;
      }
      if (b.dataset.kitEdit) {
        if (!(await this.resolveDraft())) return;
        this.activeItem = b.dataset.kitEdit;
        const item = this.items.find((i) => i.id === this.activeItem);
        this.d = normalize(item.design);
        this.draftQuantity = item.quantity;
        this.undoStack = [];
        this.render();
        this.$('.panel').scrollIntoView({ block: 'start', behavior: 'instant' });
        this.$('[data-action="add-kit"]').focus({ preventScroll: true });
        return;
      }
      if (b.dataset.kitRemove) {
        this.kitHistory.push(
          JSON.stringify({
            type: 'remove',
            item: this.items.find((i) => i.id === b.dataset.kitRemove),
            index: this.items.findIndex((i) => i.id === b.dataset.kitRemove),
          }),
        );
        if (this.kitHistory.length > 10) this.kitHistory.shift();
        this.items = this.items.filter((i) => i.id !== b.dataset.kitRemove);
        if (this.activeItem === b.dataset.kitRemove) {
          this.activeItem = null;
          this.undoStack = [];
        }
        this.render();
        this.message('Removed from kit. Use Undo kit removal / import to restore.');
        return;
      }
      const action = b.dataset.action;
      if (action === 'review-kit') {
        const heading = this.$('[data-kit-heading]');
        heading.focus({ preventScroll: true });
        heading.scrollIntoView({ block: 'start', behavior: 'instant' });
        return;
      }
      if (action === 'add-kit') {
        this.saveItem();
        return;
      }
      if (action === 'compare') {
        if (!(await this.resolveDraft())) return;
        this.activeItem = null;
        this.isAlternative = true;
        this.undoStack = [];
        this.step = 0;
        this.render();
        this.message('Editing a new alternative. Your original is preserved.');
        return;
      }
      if (action === 'undo-kit') {
        const prior = this.kitHistory[this.kitHistory.length - 1];
        if (prior) {
          const data = JSON.parse(prior);
          if (data.type === 'remove') {
            if (this.items.length >= 12) {
              this.message('Remove an item to make room for the restored garment.');
              return;
            }
            this.items.splice(data.index, 0, data.item);
            if (
              !this.activeItem &&
              JSON.stringify(normalize(this.d)) === JSON.stringify(data.item.design)
            ) {
              this.activeItem = data.item.id;
              this.draftQuantity = data.item.quantity;
              this.undoStack = [];
            }
          } else {
            const choice = await this.choose('Restore the kit from before the import?', [
              ['restore', 'Download current backup and restore'],
              ['cancel', 'Keep current kit'],
            ]);
            if (choice !== 'restore') return;
            this.download(
              JSON.stringify(this.project(), null, 2),
              'application/json',
              'project.json',
            );
            this.loadProject(readProject(data));
          }
          this.kitHistory.pop();
          this.render();
          this.message('Kit action undone.');
        } else this.message('No kit removal or import to undo.');
        return;
      }
      if (action === 'toggle-alternatives') {
        this.hideAlternatives = !this.hideAlternatives;
        this.renderKit();
        return;
      }
      if (action === 'resolve-conflict') {
        this.download(JSON.stringify(this.project(), null, 2), 'application/json', 'project.json');
        try {
          const raw = localStorage.getItem(this.storageKey);
          if (raw) {
            const project = readProject(JSON.parse(raw));
            this.loadProject(project);
            this.revision = project.revision || null;
          } else this.revision = null;
          this.conflict = false;
          this.$('[data-conflict]').hidden = true;
          this.render();
        } catch {
          this.message('Latest draft could not be loaded. Your backup is available.');
        }
        return;
      }
      if (action === 'save') {
        await this.persist();
        return;
      }
      if (action === 'import') this.$('[data-import]').click();
      if (action === 'download') {
        this.download(JSON.stringify(this.project(), null, 2), 'application/json', 'project.json');
        this.message('SmartKits project saved. Use Open project to edit it again.');
      }
      if (action === 'svg') this.download(sheet(this.d), 'image/svg+xml', 'artwork.svg');
      if (action === 'unlink-logo') {
        this.checkpoint();
        this.d.wrapSource = null;
        this.render();
        this.message('Front and back logos are independent again.');
      }
      if (action === 'rotate-logo') {
        this.checkpoint();
        const v = this.editLogo();
        v.logoRotation = ((v.logoRotation + 90 + 180) % 360) - 180;
        this.d.wrapSource = this.side;
        this.render();
      }
      if (action === 'reset-logo') {
        this.checkpoint();
        this.d.wrapSource = null;
        const v = this.d.views[this.side];
        Object.assign(v, designLogoPlacement(this.d,this.side), { logoAuto: true });
        this.render();
        this.message('Logo returned to its garment placement.');
      }
      if (action === 'crop-left' || action === 'crop-right') {
        this.checkpoint();
        const v = this.d.views[this.side],
          left = action === 'crop-left';
        const edge = this.d.product === 'shorts' ? 100 : this.d.product === 'pants' ? 125 : 125;
        Object.assign(v, {
          logoAuto: false,
          logoX: left ? edge : 400 - edge,
          logoY: this.d.product === 'shorts' ? 255 : 280,
          logoSize: 260,
        });
        this.d.wrapSource = this.side;
        this.render();
        this.message(
          'Cropped at the ' +
            (left ? 'left' : 'right') +
            ' edge. Adjust position and size to suit your artwork.',
        );
      }
      if (action === 'stb-logo') {
        this.checkpoint();
        Object.assign(
          this.d.views[this.side],
          designLogoPlacement(this.d,this.side),
          { logo: '', defaultLogo: true, logoAuto: true },
        );
        this.render();
      }
      if (action === 'remove-logo') {
        this.checkpoint();
        this.d.wrapSource = null;
        this.d.views[this.side].logo = '';
        this.d.views[this.side].defaultLogo = false;
        this.render();
      }
      if (action === 'undo') {
        if (this.undoStack.length) {
          this.d = normalize(JSON.parse(this.undoStack.pop()));
          this.render();
          this.message('Last edit undone.');
        } else this.message('There are no edits to undo.');
      }
      if (action === 'png') {
        b.disabled = true;
        try {
          this.download(await this.pngBlob(this.d), 'image/png', 'concept.png');
          this.message(
            'Front/back image ready. Use the download link below if your browser did not save it.',
          );
        } catch {
          this.message('Image export failed. Your editable design can still be downloaded.');
        } finally {
          b.disabled = false;
        }
      }
    }
    input(e) {
      const t = e.target;
      const item = this.items.find(
        (i) => i.id === (t.dataset.kitSelect || t.dataset.kitName || t.dataset.kitQuantity),
      );
      if (item) {
        if (t.dataset.kitSelect) item.selected = t.checked;
        if (t.dataset.kitName) item.name = t.value.slice(0, 80);
        if (t.dataset.kitQuantity) {
          item.quantity = t.value;
          t.setAttribute('aria-invalid', String(!validQuantity(t.value)));
          t.closest('.kit-card').querySelector('[data-quantity-error]').textContent = validQuantity(
            t.value,
          )
            ? ''
            : 'Use a whole number from 1 to 10,000.';
          if (item.id === this.activeItem) this.draftQuantity = t.value;
        }
        this.scheduleSave();
        this.updateKitSummary();
        if (t.dataset.kitSelect) this.renderKit();
        return;
      }
      if (t.hasAttribute('data-draft-quantity')) {
        this.draftTouched = true;
        this.draftQuantity = t.value;
        t.setCustomValidity(validQuantity(t.value) ? '' : 'Enter a whole number from 1 to 10,000.');
        this.scheduleSave();
        this.renderKit();
        return;
      }
      if (t.hasAttribute('data-pinstripe-toggle')) {
        this.checkpoint();
        this.d.pinstripe = { ...this.d.pinstripe, enabled: t.checked };
        this.render();
      }
      if (t.hasAttribute('data-pinstripe-color')) {
        this.checkpoint();
        this.d.pinstripe.color = color(t.value, '#ffffff');
        this.preview();
      }
      if (t.dataset.color) {
        this.checkpoint();
        this.d.colors[t.dataset.color] = color(t.value, this.d.colors[t.dataset.color]);
        this.preview();
      }
      if (t.dataset.field) {
        if (t.type === 'number') {
          const ok =
            t.value.trim() !== '' &&
            Number.isInteger(Number(t.value)) &&
            Number(t.value) >= Number(t.min) &&
            Number(t.value) <= Number(t.max);
          t.setCustomValidity(ok ? '' : 'Enter a whole number within the shown range.');
          t.setAttribute('aria-invalid', String(!ok));
          if (!ok) return;
        }
        if(t.dataset.field==='number'&&!/^\d{0,3}$/.test(t.value)){t.setCustomValidity('Use up to three digits.');return;}
        t.setCustomValidity('');
        if(t.dataset.field==='number'&&this.d.views[this.side].number===undefined)Object.assign(this.d.views[this.side],{numberX:200,numberY:218,numberSize:84,numberColor:this.d.views[this.side].textColor});
        this.checkpoint();
        if (['logoX', 'logoY', 'logoSize', 'logoRotation'].includes(t.dataset.field)) {
          const v = this.editLogo();
          this.d.wrapSource = this.side;
          if (v.defaultLogo && v.logoAuto)
            Object.assign(v, designLogoPlacement(this.d,this.side));
          v.logoAuto = false;
        }
        this.d.views[this.side][t.dataset.field] = ['range', 'number'].includes(t.type)
          ? clamp(t.value, Number(t.min), Number(t.max), 0)
          : t.value;
        this.querySelectorAll('[data-field="' + t.dataset.field + '"]').forEach((input) => {
          if (input !== t) input.value = this.d.views[this.side][t.dataset.field];
        });
        this.preview();
      }
      if (t.hasAttribute('data-notes')) {
        this.d.notes = t.value;
        this.preview();
      }
    }
    async change(e) {
      const t = e.target,
        file = t.files?.[0];
      if (!file) return;
      try {
        if (t.hasAttribute('data-import')) {
          if (file.size > 40000000) throw new Error('That design file is too large.');
          const project = readProject(JSON.parse(await file.text()));
          const next = project.current;
          if (!this.allowedProducts.includes(project.current.product) || project.items.some((i) => !this.allowedProducts.includes(i.design.product)))
            throw new Error('This kit includes a garment unavailable on this sport page.');
          if (!this.allowedProducts.includes(next.product))
            throw new Error('This garment is not available on this sport page.');
          const decoded = new Map();
          this.inert = true;
          try {
            for (const design of [next, ...project.items.map((i) => i.design)])
              for (const side of ['front', 'back']) {
                const logo = design.views[side].logo;
                if (logo) {
                  if (!decoded.has(logo)) decoded.set(logo, await this.raster(logo));
                  design.views[side].logo = decoded.get(logo);
                }
              }
          } finally {
            this.inert = false;
          }
          const choice = this.items.length
            ? await this.choose('Open this project?', [
                ['add', 'Add imported garments'],
                ['replace', 'Replace kit (can undo)'],
                ['cancel', 'Keep current kit'],
              ])
            : 'replace';
          if (choice === 'cancel') return;
          const imported = project.items.length
            ? project.items
            : [
                {
                  id: crypto.randomUUID(),
                  name: PRODUCTS[next.product] + ' / ' + familyName(next),
                  quantity: 1,
                  selected: true,
                  design: next,
                },
              ];
          if (choice === 'add' && this.items.length + imported.length > 12)
            throw new Error(
              'This import would exceed 12 items. Remove items first or replace the kit.',
            );
          this.kitHistory.push(JSON.stringify(this.project()));
          if (this.kitHistory.length > 10) this.kitHistory.shift();
          if (choice === 'add') {
            this.items.push(...imported.map((i) => ({ ...i, id: crypto.randomUUID() })));
            this.undoStack = [];
          } else this.loadProject(project);
          this.render();
          this.message('Project opened. Use Undo kit removal / import to restore your previous kit.');
        }
        if (t.hasAttribute('data-logo')) {
          if (!['image/png', 'image/jpeg'].includes(file.type) || file.size > 5000000)
            throw new Error('Choose a PNG or JPEG under 5 MB.');
          const side = this.side,
            url = URL.createObjectURL(file);
          this.inert = true;
          try {
            const logo = await this.raster(url);
            this.checkpoint();
            Object.assign(
              this.d.views[side],
              designLogoPlacement(this.d,this.side),
              { logo, defaultLogo: false, logoAuto: false },
            );
            this.render();
            this.message('Logo added to the ' + side + '.');
          } finally {
            this.inert = false;
            URL.revokeObjectURL(url);
          }
        }
      } catch (err) {
        this.message(
          err instanceof SyntaxError
            ? 'That file is not valid design JSON.'
            : err.message || 'Could not read this image.',
        );
      }
      t.value = '';
    }
    async raster(src) {
      const image = new Image();
      await new Promise((resolve, reject) => {
        const timer = setTimeout(
          () => reject(new Error('Logo decoding timed out. Try a smaller PNG.')),
          15000,
        );
        image.onload = () => {
          clearTimeout(timer);
          resolve();
        };
        image.onerror = () => {
          clearTimeout(timer);
          reject(new Error('This logo could not be decoded.'));
        };
        image.src = src;
      });
      if (!image.width || !image.height || image.width * image.height > 40000000)
        throw new Error('Choose a smaller image, up to 40 megapixels.');
      const scale = Math.min(1, 600 / image.width, 600 / image.height),
        c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(image.width * scale));
      c.height = Math.max(1, Math.round(image.height * scale));
      c.getContext('2d').drawImage(image, 0, 0, c.width, c.height);
      return c.toDataURL('image/png');
    }
    download(content, type, suffix) {
      const url = URL.createObjectURL(
          content instanceof Blob ? content : new Blob([content], { type }),
        ),
        a = document.createElement('a');
      a.href = url;
      a.download =
        suffix === 'project.json'
          ? 'stb-team-kit-project.json'
          : 'stb-' + this.d.product + '-' + suffix;
      document.body.append(a);
      a.click();
      a.remove();
      const link = document.createElement('a');
      link.href = url;
      link.download = a.download;
      link.textContent = 'Save ' + a.download;
      const old = this.$('[data-download-link]');
      if (old) {
        URL.revokeObjectURL(old.href);
        old.remove();
      }
      link.dataset.downloadLink = '';
      this.$('.status').after(link);
    }
  }
  customElements.define('stb-design-studio',Studio);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stb-team-store"] && !Shopify.designMode) return;
  try {
    
  function initTeamStoreCountdowns() {
    document.querySelectorAll('[data-countdown-deadline]').forEach(function (countdown) {
      var deadlineValue = countdown.getAttribute('data-countdown-deadline');
      var deadline = new Date(deadlineValue);
      var message = countdown.querySelector('[data-countdown-message]');
      var days = countdown.querySelector('[data-countdown-days]');
      var hours = countdown.querySelector('[data-countdown-hours]');
      var minutes = countdown.querySelector('[data-countdown-minutes]');
      var seconds = countdown.querySelector('[data-countdown-seconds]');
      var activeMessage = countdown.getAttribute('data-countdown-active-message');
      var expiredMessage = countdown.getAttribute('data-countdown-expired-message');

      if (!deadlineValue || Number.isNaN(deadline.getTime())) {
        countdown.hidden = true;
        return;
      }

      function pad(value) {
        return String(value).padStart(2, '0');
      }

      function render() {
        var remaining = deadline.getTime() - Date.now();

        if (remaining <= 0) {
          message.textContent = expiredMessage;
          days.textContent = '00';
          hours.textContent = '00';
          minutes.textContent = '00';
          seconds.textContent = '00';
          return;
        }

        var totalSeconds = Math.floor(remaining / 1000);
        var dayCount = Math.floor(totalSeconds / 86400);
        var hourCount = Math.floor((totalSeconds % 86400) / 3600);
        var minuteCount = Math.floor((totalSeconds % 3600) / 60);
        var secondCount = totalSeconds % 60;

        message.textContent = activeMessage;
        days.textContent = pad(dayCount);
        hours.textContent = pad(hourCount);
        minutes.textContent = pad(minuteCount);
        seconds.textContent = pad(secondCount);
      }

      render();
      window.setInterval(render, 1000);
    });
  }

  initTeamStoreCountdowns();

  function initEliteDesignPicker() {
    var picker = document.querySelector('[data-elite-design-picker]');
    if (!picker) return;

    var products = document.querySelector('[data-elite-products]');
    var heading = document.querySelector('[data-elite-products-heading]');
    var cards = Array.prototype.slice.call(picker.querySelectorAll('[data-elite-design]'));
    var productCards = Array.prototype.slice.call(document.querySelectorAll('[data-elite-product]'));
    var filters = document.querySelector('[data-elite-filters]');
    var changeDesign = document.querySelector('[data-elite-change-design]');

    function selectDesign(card) {
      var design = card.getAttribute('data-elite-design');
      var designNumber = design.replace('Art ', '');
      var designLabel = card.getAttribute('data-elite-design-label');

      cards.forEach(function (item) {
        item.setAttribute('aria-pressed', String(item === card));
      });

      productCards.forEach(function (productCard) {
        var imageUrl = productCard.getAttribute('data-art-' + designNumber + '-image');
        var image = productCard.querySelector('.team-product__image img');
        if (image && imageUrl) {
          image.src = imageUrl;
          image.srcset = '';
          image.alt = productCard.querySelector('h3')?.textContent.trim() + ' — ' + designLabel;
        }

        productCard.querySelectorAll('[data-elite-product-link]').forEach(function (link) {
          var url = new URL(link.href, window.location.origin);
          url.searchParams.set('design', design);
          link.href = url.pathname + url.search;
        });
      });

      products.hidden = false;
      heading.hidden = false;
      filters.hidden = false;
      heading.querySelector('h2').textContent = picker.getAttribute('data-elite-garment-heading') + ' — ' + designLabel;
      history.replaceState({}, '', window.location.pathname + '?design=' + encodeURIComponent(design) + '#team-store-products');
      heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectDesign(card);
      });
    });

    changeDesign.addEventListener('click', function () {
      picker.scrollIntoView({ behavior: 'smooth', block: 'start' });
      cards.find(function (card) {
        return card.getAttribute('aria-pressed') === 'true';
      })?.focus();
    });

    filters.querySelectorAll('[data-elite-filter]').forEach(function (filterButton) {
      filterButton.addEventListener('click', function () {
        var filter = filterButton.getAttribute('data-elite-filter');
        filters.querySelectorAll('[data-elite-filter]').forEach(function (item) {
          item.setAttribute('aria-pressed', String(item === filterButton));
        });
        productCards.forEach(function (productCard) {
          productCard.hidden = filter !== 'all' && productCard.getAttribute('data-elite-category') !== filter;
        });
      });
    });

    var initialDesign = new URLSearchParams(window.location.search).get('design');
    var initialCard = cards.find(function (card) {
      return card.getAttribute('data-elite-design') === initialDesign;
    });
    if (initialCard) selectDesign(initialCard);
  }

  initEliteDesignPicker();

  } catch(e) { console.error(e); }
})();
})();
